"use strict";

π.add('api', function () {
  // PRIVATE
  var CONF = {},
    PRIV = {
      getUrl: function getUrl(endpoint) {
        if (π.server.isHostIPv4()) {
          var url = new URL(π.server.getUrl('api') + _.replace(endpoint, π.server.getUrl('api'), ''));
          url.searchParams.set('router', 'api');
          return url.toString();
        } else {
          return π.server.getUrl('api') + _.replace(endpoint, π.server.getUrl('api'), '');
        }
      }
    },
    _refs = {},
    _vars = {};

  // PUBLIC
  return {
    _refs: {},
    _vars: {},
    // methods
    get: function get(endpoint, options) {
      return axios.get(PRIV.getUrl(endpoint), options);
    },
    put: function put(endpoint, data, options) {
      return axios.put(PRIV.getUrl(endpoint), data, options);
    },
    post: function post(endpoint, data, options) {
      return axios.post(PRIV.getUrl(endpoint), data, options);
    },
    patch: function patch(endpoint, data, options) {
      return axios.patch(PRIV.getUrl(endpoint), data, options);
    },
    "delete": function _delete(endpoint, data, options) {
      return axios["delete"](PRIV.getUrl(endpoint), options);
    },
    head: function head(endpoint, data, options) {
      return axios.head(PRIV.getUrl(endpoint), options);
    }
  };
}());;"use strict";

π.add('app', function () {
  // PRIVATE
  var CONF = {},
    PRIV = {
      helpers: {
        init: function init() {
          π.helpers.utils.applyMethods(π, 'app.helpers', '**init');
        }
      },
      mixins: {
        init: function init() {
          π.helpers.utils.applyMethods(π, 'app.mixins', '**init');
        }
      },
      modules: {
        init: function init() {
          π.helpers.utils.applyMethods(π, 'app.modules', '**init');
        }
      },
      chunks: {
        init: function init() {
          π.helpers.utils.applyMethods(π, 'app.chunks', '**init');
        }
      },
      head: {
        init: function init() {
          π.helpers.utils.applyMethods(π, 'app.head', '**init');
        }
      },
      win: {
        init: function init() {
          π.main.refs.window.on({
            'scroll': π.helpers.scroll.onScroll,
            'mousemove': π.helpers.mouse.onMouseMove,
            'mousedown': π.app.win.onMouseDown,
            'mouseup': π.app.win.onMouseUp,
            'mouseout': π.app.win.onMouseOut,
            'hashchange': π.helpers.url.onHashChange,
            'popstate': π.helpers.url.onPopState,
            'resize': π.helpers.resize.onWindowResize,
            'focus': π.app.win.onWindowFocus,
            'focusin': π.app.win.onWindowFocusIn,
            'focusout': π.app.win.onWindowFocusOut
          });
          π.main.refs.html.find('*').on({
            'scroll': π.helpers.scroll.onScroll
          });
          window.addEventListener('wheel', π.helpers.mouse.onWheel, {
            'passive': false
          });
          if ('onorientationchange' in window) {
            π.main.refs.window.on({
              'orientationchange': π.app.win.onOrientationChange
            });
          }
          if (gv(π, 'main.device.isTouch')) {
            π.main.refs.document.on({
              'touchstart': π.helpers.mobile.onTouchStart,
              'touchmove': π.helpers.mobile.onTouchMove,
              'touchend': π.helpers.mobile.onTouchEnd
            }, '*');
          }
        }
      },
      doc: {
        init: function init() {
          π.main.refs.document.on({
            'keyup': π.app.doc.onKeyUp,
            'keydown': π.app.doc.onKeyDown
          });
        }
      },
      html: {
        init: function init() {
          new MutationObserver(π.helpers.html.onHTMLMutation).observe(π.main.refs.html[0], {
            'attributes': true,
            'childList': true,
            'subtree': true
          });
        }
      },
      app: {
        init: function init() {
          π.helpers.utils.applyMethod(π, 'app._ext.init');
          π.main.refs.window.trigger('scroll');
        }
      }
    },
    _refs = {},
    _vars = {};

  // PUBLIC
  return {
    _refs: {},
    _vars: {},
    // methods
    init: function init() {
      // log('init core app');
      PRIV.helpers.init();
      PRIV.win.init();
      PRIV.doc.init();
      PRIV.html.init();
      PRIV.mixins.init();
      PRIV.modules.init();
      PRIV.chunks.init();
      PRIV.head.init();
      PRIV.app.init();
    },
    // objects
    win: {
      onResize: function onResize(e) {
        π.helpers.utils.applyMethods(π, ['helpers', 'app.helpers', 'app.mixins', 'app.modules', 'app.chunks'], '**onResize', [e], null, {
          'cache': 'π.app.win.onResize'
        });
      },
      onResizeInstant: function onResizeInstant(e) {
        π.helpers.utils.applyMethods(π, ['helpers', 'app.helpers', 'app.mixins', 'app.modules', 'app.chunks'], '**onResizeInstant', [e], null, {
          'cache': 'π.app.win.onResizeInstant'
        });
      },
      onOrientationChange: function onOrientationChange(e) {
        π.helpers.utils.applyMethods(π, ['helpers', 'app.helpers', 'app.mixins', 'app.modules', 'app.chunks'], '**onOrientationChange', [e], null, {
          'cache': 'π.app.win.onOrientationChange'
        });
      },
      onScroll: function onScroll(e) {
        π.helpers.utils.applyMethods(π, ['helpers', 'app.helpers', 'app.mixins', 'app.modules', 'app.chunks'], '**onScroll', [e], null, {
          'cache': 'π.app.win.onScroll',
          'rejects': [π.helpers.scroll.onScroll]
        });
      },
      onScrollFinished: function onScrollFinished(e) {
        π.helpers.utils.applyMethods(π, ['helpers', 'app.helpers', 'app.mixins', 'app.modules', 'app.chunks'], '**onScrollFinished', [e], null, {
          'cache': 'π.app.win.onScrollFinished',
          'rejects': [π.helpers.scroll.onScrollFinished]
        });
      },
      onScrollDirChanged: function onScrollDirChanged(dir) {
        π.helpers.utils.applyMethods(π, ['helpers', 'app.helpers', 'app.mixins', 'app.modules', 'app.chunks'], '**onScrollDirChanged', [dir], null, {
          'cache': 'π.app.win.onScrollDirChanged'
        });
      },
      onWheel: function onWheel(e) {
        π.helpers.utils.applyMethods(π, ['helpers', 'app.helpers', 'app.mixins', 'app.modules', 'app.chunks'], '**onWheel', [e], null, {
          'cache': 'π.app.win.onWheel',
          'rejects': [π.helpers.mouse.onWheel]
        });
      },
      onMouseMove: function onMouseMove(e) {
        π.helpers.utils.applyMethods(π, ['helpers', 'app.helpers', 'app.mixins', 'app.modules', 'app.chunks'], '**onMouseMove', [e], null, {
          'cache': 'π.app.win.onMouseMove',
          'rejects': [π.helpers.mouse.onMouseMove]
        });
      },
      onMouseDown: function onMouseDown(e) {
        π.helpers.utils.applyMethods(π, ['helpers', 'app.helpers', 'app.mixins', 'app.modules', 'app.chunks'], '**onMouseDown', [e], null, {
          'cache': 'π.app.win.onMouseDown'
        });
      },
      onMouseUp: function onMouseUp(e) {
        π.helpers.utils.applyMethods(π, ['helpers', 'app.helpers', 'app.mixins', 'app.modules', 'app.chunks'], '**onMouseUp', [e], null, {
          'cache': 'π.app.win.onMouseUp'
        });
      },
      onMouseOut: function onMouseOut(e) {
        π.helpers.utils.applyMethods(π, ['helpers', 'app.helpers', 'app.mixins', 'app.modules', 'app.chunks'], '**onMouseOut', [e], null, {
          'cache': 'π.app.win.onMouseOut'
        });
      },
      onTouchStart: function onTouchStart(e) {
        π.helpers.utils.applyMethods(π, ['helpers', 'app.helpers', 'app.mixins', 'app.modules', 'app.chunks'], '**onTouchStart', [e], null, {
          'cache': 'π.app.win.onTouchStart',
          'rejects': [π.helpers.mobile.onTouchStart]
        });
      },
      onTouchMove: function onTouchMove(e) {
        π.helpers.utils.applyMethods(π, ['helpers', 'app.helpers', 'app.mixins', 'app.modules', 'app.chunks'], '**onTouchMove', [e], null, {
          'cache': 'π.app.win.onTouchMove',
          'rejects': [π.helpers.mobile.onTouchMove]
        });
      },
      onTouchEnd: function onTouchEnd(e) {
        π.helpers.utils.applyMethods(π, ['helpers', 'app.helpers', 'app.mixins', 'app.modules', 'app.chunks'], '**onTouchEnd', [e], null, {
          'cache': 'π.app.win.onTouchEnd',
          'rejects': [π.helpers.mobile.onTouchEnd]
        });
      },
      onHashChange: function onHashChange(e) {
        π.helpers.utils.applyMethods(π, ['helpers', 'app.helpers', 'app.mixins', 'app.modules', 'app.chunks'], '**onHashChange', [e], null, {
          'cache': 'π.app.win.onHashChange',
          'rejects': [π.helpers.url.onHashChange]
        });
      },
      onWindowFocus: function onWindowFocus(e) {
        π.helpers.utils.applyMethods(π, ['helpers', 'app.helpers', 'app.mixins', 'app.modules', 'app.chunks'], '**onWindowFocus', [e], null, {
          'cache': 'π.app.win.onWindowFocus'
        });
      },
      onWindowFocusIn: function onWindowFocusIn(e) {
        π.helpers.utils.applyMethods(π, ['helpers', 'app.helpers', 'app.mixins', 'app.modules', 'app.chunks'], '**onWindowFocusIn', [e], null, {
          'cache': 'π.app.win.onWindowFocusIn'
        });
      },
      onWindowFocusOut: function onWindowFocusOut(e) {
        π.helpers.utils.applyMethods(π, ['helpers', 'app.helpers', 'app.mixins', 'app.modules', 'app.chunks'], '**onWindowFocusOut', [e], null, {
          'cache': 'π.app.win.onWindowFocusOut'
        });
      }
    },
    doc: {
      onKeyUp: function onKeyUp(e) {
        π.helpers.utils.applyMethods(π, ['helpers', 'app.helpers', 'app.mixins', 'app.modules', 'app.chunks'], '**onKeyUp', [e], null, {
          'cache': 'π.app.doc.onKeyUp'
        });
      },
      onKeyDown: function onKeyDown(e) {
        π.helpers.utils.applyMethods(π, ['helpers', 'app.helpers', 'app.mixins', 'app.modules', 'app.chunks'], '**onKeyDown', [e], null, {
          'cache': 'π.app.doc.onKeyDown'
        });
      }
    },
    html: {
      onHTMLMutation: function onHTMLMutation(mutationList, observer) {
        π.helpers.utils.applyMethods(π, ['helpers', 'app.helpers', 'app.mixins', 'app.modules', 'app.chunks'], '**onHTMLMutation', [mutationList, observer], null, {
          'cache': 'π.app.html.onHTMLMutation',
          'rejects': [π.helpers.html.onHTMLMutation]
        });
      }
    }
  };
}());;"use strict";

π.add('helpers', function () {
  // PRIVATE
  var CONF = {},
    PRIV = {},
    _refs = {},
    _vars = {};

  // PUBLIC
  return {
    _refs: {},
    _vars: {},
    // methods
    init: function init() {
      π.helpers.setup.init();
      π.helpers.utils.applyMethods(π, 'helpers', '**init', undefined, undefined, {
        'rejects': [π.helpers.init, π.helpers.setup.init]
      });
    }
  };
}());;"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
π.add('main', function (_ref) {
  return {
    refs: {
      window: $(window),
      document: $(document),
      html: $('html'),
      body: $('body'),
      main: $('#main'),
      header: $('#header'),
      footer: $('#footer'),
      navigation: $('#navigation'),
      aside: $('#aside')
    },
    config: {
      stats: {
        isActived: false,
        isParameterMandatory: false
      }
    },
    device: {
      isMac: false,
      isWin: false,
      isLocal: false,
      isProduction: false,
      isTouch: false,
      isMobile: false,
      isApp: false,
      isIOSApp: false,
      isAndroidApp: false,
      isIOS: false,
      isIOSChrome: false,
      isIOSFirefox: false,
      isIOSSafari: false,
      isAndroid: false,
      isAndroidNative: false,
      isAndroidChrome: false,
      isAndroidDeprecated: false,
      isIE: false,
      isltIE9: false,
      isltIE10: false,
      isltIE11: false,
      isEdge: false,
      isSafari: false,
      isFirefox: false,
      isChrome: false,
      safariPopedIntitalState: false
    },
    window: {
      innerWidth: $(window).innerWidth(),
      innerHeight: $(window).innerHeight(),
      outerWidth: $(window).outerWidth(),
      outerHeight: $(window).outerHeight(),
      scrollTop: 0,
      scrollLeft: 0,
      scrollDir: {
        vertical: 'down',
        horizontal: 'right'
      },
      srollHistory: {
        vertical: [],
        horizontal: []
      },
      scrollDisabled: false,
      scrollPreventEventOnce: false,
      scrollPreventHorizontal: false,
      onScroll: false,
      mouseWheelDir: undefined,
      mouseOffsetX: undefined,
      mouseOffsetY: undefined,
      mouseClientX: undefined,
      mouseClientY: undefined,
      touchClientHistoryX: [],
      touchClientHistoryY: [],
      usesTrackPad: false,
      location: {
        hash: _.get(location, 'hash')
      }
    },
    document: {
      loadedAt: Date.now(),
      isIframe: false,
      width: $(document).width(),
      height: $(document).height()
    },
    service: _.get(location, 'host').startsWith('cms') ? 'cms' : 'app',
    data: {
      server: (_ref = _).merge.apply(_ref, _toConsumableArray(typeof serverTranslations !== 'undefined' ? [{
        translations: serverTranslations
      }] : [{}]).concat(_toConsumableArray(_.map($('[data-server]'), function (that) {
        return _defineProperty({}, _.camelCase($(that).data('server')), JSON.parse(LZString.decompressFromBase64($(that).text())));
      }))))
    },
    constants: {
      duration: {
        HTMLMutationTimeout: 200,
        resizeTimeout: 200,
        scrollTimeout: 300
      }
    },
    functions: {
      HTMLMutationTimeout: undefined,
      resizeTimeout: undefined,
      scrollTimeout: undefined,
      popstateTimeout: undefined
    }
  };
}());
π.main.refs.document.ready(function () {
  π.helpers.init();
  π.app.init();
});;"use strict";

π.add('server', function () {
  // PRIVATE
  var CONF = {},
    PRIV = {},
    _refs = {},
    _vars = {};

  // PUBLIC
  return {
    _refs: {},
    _vars: {},
    // methods
    isNodeApp: function isNodeApp() {
      return π.server.isWordpressApp() == false;
    },
    isWordpressApp: function isWordpressApp() {
      return typeof templateDirectoryURI == 'string';
    },
    isNodeEnvDevelopment: function isNodeEnvDevelopment() {
      return gv(π, 'main.data.server.config.process.env.NODE_ENV', false) == 'development';
    },
    isNodeEnvTesting: function isNodeEnvTesting() {
      return gv(π, 'main.data.server.config.process.env.NODE_ENV', false) == 'testing';
    },
    isNodeEnvProduction: function isNodeEnvProduction() {
      return gv(π, 'main.data.server.config.process.env.NODE_ENV', false) == 'production';
    },
    isHostIPv4: function isHostIPv4() {
      return gv(location, 'host').match(new RegExp('^[1-9]{1,3}\.')) !== null;
    },
    getProtocol: function getProtocol() {
      return _.trimEnd(gv(location, 'protocol'), ':');
    },
    getSpace: function getSpace() {
      var service = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'app';
      return gv(location, 'hostname').startsWith('www.') && !['cms', 'api'].includes(service) ? 'www.' : '';
    },
    getPort: function getPort(service) {
      return service == 'db' ? gv(π, 'main.data.server.config.db.port') : gv(location, 'port');
    },
    getHost: function getHost() {
      var service = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'app';
      if (['cms', 'api'].includes(service)) {
        return (π.server.isHostIPv4() ? '' : gv(π, 'main.data.server.config.' + service + '.subdomain') + '.') + π.server.getHost('app');
      } else {
        return gv(location, 'hostname').replace(/^www\./, '').replace(/^cms\./, '');
      }
    },
    getUrl: function getUrl() {
      var service = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'app';
      if (π.server.isNodeApp()) {
        var protocol = π.server.getProtocol(),
          space = π.server.getSpace(service),
          host = π.server.getHost(service),
          server = gv(π, 'main.data.server.config.process.env.SERVER', false),
          port = server == 'local' ? ':' + π.server.getPort(service) : '';
        return protocol + '://' + space + host + port;
      } else if (π.server.isWordpressApp()) {
        return templateDirectoryURI;
      } else {
        return undefined;
      }
    },
    getPublic: function getPublic() {
      var service = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'app';
      return π.server.getUrl(service) + (π.server.isWordpressApp() ? '/public' : '');
    },
    getService: function getService() {
      return gv(location, 'hostname').startsWith('cms.') ? 'cms' : gv(location, 'hostname').startsWith('api.') ? 'api' : 'app';
    }
  };
}());;"use strict";

π.add('app.mixins.duplicate', function () {
  // PRIVATE
  var CONF = {},
    PRIV = {
      add: function add() {
        var that = $(this),
          wrapper = that.closest('.mixin-duplicate'),
          duplicates = wrapper.find('.duplicate-item'),
          max = wrapper.data('duplicate-max');
        if (!max || max > gl(duplicates)) {
          var clone = PRIV.getClone(gl(duplicates) ? duplicates.first() : gv(_vars, 'lastClone'));
          π.helpers.utils.applyMethod(π.app.mixins.duplicate, '_ext.onAdd', [clone], this);
          if (gl(duplicates)) {
            wrapper.find('.duplicate-item').last().after(clone);
          } else {
            wrapper.prepend(clone);
          }
          PRIV.replaceIndexPattern(wrapper);
          PRIV.replaceHTML(clone);
          π.helpers.utils.applyMethod(π.app.mixins.fold, 'expand', [that.closest('.fold-content')]);
        }
      },
      remove: function remove() {
        var that = $(this),
          wrapper = that.closest('.mixin-duplicate'),
          item = that.closest('.duplicate-item'),
          min = wrapper.data('duplicate-min'),
          foldContent = item.closest('.fold-content');
        if (gl(wrapper.find('.duplicate-item')) > min || !min && gl(wrapper.find('.duplicate-item')) > 1) {
          _.set(_vars, 'lastClone', PRIV.getClone(item));
          item.remove();
          PRIV.setIndex(wrapper);
          π.helpers.utils.applyMethod(π.app.mixins.fold, 'expand', [foldContent]);
        } else if (gl(wrapper.find('.duplicate-item')) === min && wrapper.data('duplicate-purge')) {
          PRIV.purge(item);
        }
        PRIV.replaceIndexPattern(wrapper);
        PRIV.replaceHTML(that);
      },
      purge: function purge(that) {
        that.find('.duplicate-ignore').remove();
        that.find('input, textarea').each(PRIV.setDefault);
        that.find('.select2').remove();
        that.find('select').each(PRIV.setDefault).removeClass('initialized-select select2-hidden-accessible').removeAttr('data-select2-id');
        that.find('.CodeMirror').remove();
        that.find('.codemirror').removeClass('initialized-codemirror');
      },
      replaceIndex: function replaceIndex(that, prefix, i) {
        that.find('[name^="' + prefix + '"]').each(function () {
          _.set(this, 'name', gv(this, 'name').replace(new RegExp(prefix + '.([0-9][0-9][0-9]|[0-9][0-9]|[0-9])'), prefix + '.' + i));
        });
      },
      replaceIndexPattern: function replaceIndexPattern(wrapper) {
        wrapper.find('.duplicate-item').each(function (i) {
          $(this).find('[data-duplicate-replace-index-pattern]').each(function () {
            var that = $(this),
              pattern = that.data('duplicate-replace-index-pattern'),
              operation = _.replace((pattern.split('{')[1] || '').split('}')[0], 'i', ''),
              plus = operation.indexOf('+') > -1,
              minus = operation.indexOf('-') > -1;
            if (plus) {
              that.html(pattern.replace(/\{\i(\+|\-)?[0-9]?\}/g, i + Number(operation.replace('+', ''))));
            } else if (minus) {
              that.html(pattern.replace(/\{\i(\+|\-)?[0-9]?\}/g, i - Number(operation.replace('-', ''))));
            } else {
              that.html(pattern.replace(/\{\i(\+|\-)?[0-9]?\}/g, i));
            }
          });
        });
      },
      replaceHTML: function replaceHTML(that) {
        that.find('[data-duplicate-replace-html]').each(function () {
          var that = $(this);
          that.html(that.data('duplicate-replace-html'));
        });
      },
      setDefault: function setDefault() {
        var that = $(this),
          defaultValue = that.data('duplicate-default');
        if (gv(this, 'tagName') == 'SELECT') {
          that.find('option[selected]').removeAttr('selected');
          that.find('option[data-select2-id]').removeAttr('data-select2-id');
          if (gv(this, 'multiple')) {
            that.val(defaultValue !== undefined ? defaultValue : []);
          }
        }
        if (gv(this, 'type') == 'checkbox' || gv(this, 'type') == 'radio') {
          that.prop('checked', defaultValue === true);
        } else if (gv(this, 'tagName') != 'SELECT') {
          that.val(defaultValue !== undefined ? π.helpers.json.getStringified(defaultValue) : '');
        }
      },
      setIndex: function setIndex(wrapper, clone) {
        var prefix = wrapper.data('duplicate-set-index-after');
        if (prefix) {
          if (clone) {
            PRIV.replaceIndex(clone, prefix, gl(wrapper.find('.duplicate-item')));
          } else {
            wrapper.find('.duplicate-item').each(function (i) {
              PRIV.replaceIndex($(this), prefix, i);
            });
          }
        }
      },
      setId: function setId(wrapper, clone) {
        var prefix = wrapper.data('duplicate-set-id-after');
        if (prefix) {
          var id = π.helpers.utils.getUniqueId();
          clone.find('[name^="' + prefix + '"]').each(function () {
            var stringMinusPrefix = gv(this, 'name').replace(prefix + '.', '');
            _.set(this, 'name', prefix + '.' + id + stringMinusPrefix.slice(stringMinusPrefix.indexOf('.')));
          });
        }
      },
      getClone: function getClone(that) {
        var clone = that.clone(),
          wrapper = that.closest('.mixin-duplicate');
        PRIV.purge(clone);
        PRIV.setId(wrapper, clone);
        PRIV.setIndex(wrapper, clone);
        return clone;
      }
    },
    _refs = {},
    _vars = {
      lastClone: undefined
    };

  // PUBLIC
  return {
    _refs: {},
    _vars: {},
    // methods
    init: function init() {
      π.main.refs.main.on({
        'click': PRIV.add
      }, '.mixin-duplicate .duplicate-add');
      π.main.refs.main.on({
        'click': PRIV.remove
      }, '.mixin-duplicate .duplicate-remove');
    }
  };
}());;"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
π.add('app.mixins.form', function () {
  // PRIVATE
  var CONF = {},
    PRIV = {
      // objects
      worker: {
        init: function init() {
          if (π.helpers.data.isFunction(π, 'app.head.worker.unregister')) {
            π.main.refs.body.on({
              'submit.unregister-service-worker': π.app.head.worker.unregister
            }, 'form.unregister-service-worker');
          }
        }
      },
      csrf: {
        init: function init() {
          π.main.refs.body.find('form[method=post]').each(function () {
            var that = $(this),
              csrf = π.helpers.cookies.get('_csrf');
            if (!gl(that.find('input[name=_csrf]')) && csrf) {
              that.prepend('<input type="hidden" name="_csrf" value="' + csrf + '">');
            }
          });
        }
      },
      ajax: {
        init: function init() {
          π.main.refs.body.on({
            'submit.ajax-form': PRIV.ajax.onSubmit
          }, 'form.ajax-form');
          π.main.refs.body.on({
            'ce.form.verify': PRIV.ajax.onVerify
          }, 'form.ajax-form');
        },
        submit: function submit(e, options) {
          var _this = this;
          var that = $(this);
          if (!that.hasClass('error-flag')) {
            var url = that.trigger('ce.form.request').attr('action'),
              trigger = $(gv(e, 'originalEvent.submitter', false)),
              triggerName = trigger.attr('name'),
              triggerValue = trigger.attr('value');
            var data = π.app.mixins.form.getFormData(that);
            if (that.attr('enctype') == 'multipart/form-data') {
              data = new FormData(this);
              data["delete"]('_csrf');
            }
            if (triggerName && triggerValue && gv(data, triggerName, false)) {
              _.set(data, triggerName, triggerValue);
            }
            if (that.data('helper-loading')) {
              π.helpers.loading.show();
            }
            if (that.data('helper-loading-overlay')) {
              π.app.modules.overlay.loading.show();
            }
            axios.post(url, data).then(function (res) {
              that.trigger('ce.form.submit', [res]);
              if (π.helpers.data.isFunction(window, gv(res, 'data.callback', false))) {
                π.helpers.utils.applyMethod(window, gv(res, 'data.callback'), [res], _this);
              } else if (gv(res, 'data.redirect', false)) {
                location.assign(gv(res, 'data.redirect'));
              } else if (gv(res, 'data.overlay-url', false)) {
                π.helpers.utils.applyMethod(π, 'app.modules.overlay.load', [gv(res, 'data.overlay-url')]);
              } else if (gv(res, 'data.overlay-close', false)) {
                π.helpers.utils.applyMethod(π, 'app.modules.overlay.close');
              } else if (gv(res, 'data.reload', false) !== false) {
                location.reload();
              }
            })["catch"](function (err) {
              console.error(err);
              that.trigger('ce.form.error', [err]);
            });
          }
        },
        onSubmit: function onSubmit(e) {
          var that = $(this);
          if (that.hasClass('validate-wrapper')) {
            e.preventDefault();
            _.set(_vars, 'lastSubmit', Date.now());
          } else {
            π.helpers.utils.applyMethod(PRIV, 'ajax.submit', [e], this);
          }
        },
        onVerify: function onVerify(e, triggerEvent, triggerEventOptions) {
          if (gv(triggerEvent, 'type', false) == 'submit') {
            triggerEvent.preventDefault();
            π.helpers.utils.applyMethod(PRIV, 'ajax.submit', [triggerEvent, triggerEventOptions], this);
          }
        }
      },
      focus: {
        init: function init() {
          π.main.refs.body.find('[data-focus]').each(function () {
            if (gv(this, 'tagName') != 'SELECT') {
              var that = $(this),
                val = that.val(),
                focus = that.data('focus');
              that.removeAttr('data-focus');
              if ((focus != 'if-empty' || !gl(val)) && (focus != 'if-not-empty' || gl(val))) {
                that.focus();
              }
            }
          });
        }
      },
      enter: {
        init: function init() {
          π.main.refs.body.on({
            'keydown': PRIV.enter.onKeyDown
          }, 'input');
        },
        onKeyDown: function onKeyDown(e) {
          if (gv(e, 'keyCode', false) == 13) {
            // enter
            var that = $(this),
              form = that.closest('form'),
              submit = form.find('[type=submit]');
            if (gl(form) && !gl(submit)) {
              form.trigger('submit');
            }
          }
        }
      },
      counter: {
        init: function init() {
          π.main.refs.body.find('.counter-reference:not(.initialized-counter)').each(function () {
            PRIV.counter.update($(this).addClass('initialized-counter').on({
              'blur': PRIV.counter.onBlur,
              'change': PRIV.counter.onChange,
              'keydown': PRIV.counter.onKeyDown
            }));
          });
        },
        promise: function promise(that) {
          if (!that.data('counter')) {
            var id = π.helpers.utils.getUniqueId(),
              html = '<div id="' + id + '" class="counter-wrapper">' + PRIV.counter.getText(that) + '</div>';
            that.parent().append(html);
            that.data('counter', π.main.refs.body.find('#' + id));
            if (that.hasClass('language-field')) {
              var name = that.attr('name');
              that.data('counter').addClass('language-field').addClass('language-' + name.slice(name.lastIndexOf('.') + 1));
              if (that.hasClass('language-hide')) {
                that.data('counter').addClass('language-hide');
              }
            }
          }
          return that;
        },
        update: function update(that) {
          setTimeout(function () {
            if (gl(that) === 1 && π.helpers.data.isJQueryObject(that.data('counter'))) {
              PRIV.counter.toggleClass(that, that.data('counter').html(PRIV.counter.getText(that)));
            } else {
              that.each(function () {
                PRIV.counter.update(PRIV.counter.promise($(this)));
              });
            }
          }, 1);
        },
        toggleClass: function toggleClass(that, counter) {
          var max = PRIV.counter.getMax(that);
          if (max) {
            if (PRIV.counter.getCount(that) > max) {
              that.data('counter').addClass('counter-overlength');
            } else {
              that.data('counter').removeClass('counter-overlength');
            }
          }
        },
        getMax: function getMax(that) {
          var max = that.data('max') || that.data('max-words') || that.data('max-tags');
          return !isNaN(max) && max !== '' ? Number(max) : undefined;
        },
        getCount: function getCount(that) {
          var val = _.trim(that.val());
          return that.data('max-words') ? gl(_.words(val)) : gl(val);
        },
        getText: function getText(that) {
          var max = PRIV.counter.getMax(that),
            unit = that.data('unit'),
            count = PRIV.counter.getCount(that);
          return count + (max ? ' / ' + max + (unit ? ' ' + unit : '') : '');
        },
        onBlur: function onBlur() {
          PRIV.counter.update($(this));
        },
        onChange: function onChange() {
          PRIV.counter.update($(this));
        },
        onKeyDown: function onKeyDown() {
          PRIV.counter.update($(this));
        }
      },
      uniform: {
        init: function init() {
          π.main.refs.body.on({
            'change': PRIV.uniform.onChange
          }, '.uniform input');
          π.main.refs.body.find('.uniform input').each(PRIV.uniform.check);
        },
        check: function check() {
          if (gv(this, 'checked')) {
            $(this).closest('.uniform').addClass('uniform-checked');
          } else {
            $(this).closest('.uniform').removeClass('uniform-checked');
          }
        },
        onChange: function onChange() {
          π.main.refs.body.find('.uniform input').each(PRIV.uniform.check);
        }
      },
      validation: {
        init: function init() {
          PRIV.validation.preprocess.init();
          π.main.refs.body.on({
            'submit.validate-wrapper': PRIV.validation.check
          }, '.validate-wrapper');
          π.main.refs.body.on({
            'keyup.validate-wrapper.validate-text': PRIV.validation.check
          }, '.validate-wrapper .validate-text');
          π.main.refs.body.on({
            'blur.validate-wrapper.validate-text': PRIV.validation.check
          }, '.validate-wrapper .validate-text');
          π.main.refs.body.on({
            'keyup.validate-wrapper.validate-email': PRIV.validation.check
          }, '.validate-wrapper .validate-email');
          π.main.refs.body.on({
            'blur.validate-wrapper.validate-email': PRIV.validation.check
          }, '.validate-wrapper .validate-email');
          π.main.refs.body.on({
            'keyup.validate-wrapper.validate-url': PRIV.validation.check
          }, '.validate-wrapper .validate-url');
          π.main.refs.body.on({
            'blur.validate-wrapper.validate-url': PRIV.validation.check
          }, '.validate-wrapper .validate-url');
          π.main.refs.body.on({
            'keyup.validate-wrapper.validate-slug': PRIV.validation.check
          }, '.validate-wrapper .validate-slug');
          π.main.refs.body.on({
            'blur.validate-wrapper.validate-slug': PRIV.validation.check
          }, '.validate-wrapper .validate-slug');
          π.main.refs.body.on({
            'keyup.validate-wrapper.validate-json': PRIV.validation.check
          }, '.validate-wrapper .validate-json');
          π.main.refs.body.on({
            'blur.validate-wrapper.validate-json': PRIV.validation.check
          }, '.validate-wrapper .validate-json');
          π.main.refs.body.on({
            'keyup.validate-wrapper.validate-number': PRIV.validation.check
          }, '.validate-wrapper .validate-number');
          π.main.refs.body.on({
            'blur.validate-wrapper.validate-number': PRIV.validation.check
          }, '.validate-wrapper .validate-number');
          π.main.refs.body.on({
            'keyup.validate-wrapper.validate-phone': PRIV.validation.check
          }, '.validate-wrapper .validate-phone');
          π.main.refs.body.on({
            'blur.validate-wrapper.validate-phone': PRIV.validation.check
          }, '.validate-wrapper .validate-phone');
          π.main.refs.body.on({
            'keyup.validate-wrapper.validate-password': PRIV.validation.check
          }, '.validate-wrapper .validate-password');
          π.main.refs.body.on({
            'blur.validate-wrapper.validate-password': PRIV.validation.check
          }, '.validate-wrapper .validate-password');
          π.main.refs.body.on({
            'keyup.validate-wrapper.validate-textarea': PRIV.validation.check
          }, '.validate-wrapper .validate-textarea');
          π.main.refs.body.on({
            'blur.validate-wrapper.validate-textarea': PRIV.validation.check
          }, '.validate-wrapper .validate-textarea');
          π.main.refs.body.on({
            'keyup.validate-wrapper.validate-date': PRIV.validation.check
          }, '.validate-wrapper .validate-date');
          π.main.refs.body.on({
            'blur.validate-wrapper.validate-date': PRIV.validation.check
          }, '.validate-wrapper .validate-date');
          π.main.refs.body.on({
            'keyup.validate-wrapper.validate-time': PRIV.validation.check
          }, '.validate-wrapper .validate-time');
          π.main.refs.body.on({
            'blur.validate-wrapper.validate-time': PRIV.validation.check
          }, '.validate-wrapper .validate-time');
          π.main.refs.body.on({
            'change.validate-wrapper.validate-checkbox': PRIV.validation.check
          }, '.validate-wrapper .validate-checkbox');
          π.main.refs.body.on({
            'change.validate-wrapper.validate-radio': PRIV.validation.check
          }, '.validate-wrapper .validate-radio');
          π.main.refs.body.on({
            'change.validate-wrapper.validate-select': PRIV.validation.check
          }, '.validate-wrapper .validate-select');
          π.main.refs.body.on({
            'change.validate-wrapper.validate-file': PRIV.validation.check
          }, '.validate-wrapper .validate-file');
          PRIV.validation.status.init();
        },
        check: function check(e, options) {
          var that = $(this);
          if (gv(e, 'originalEvent', false)) {
            π.helpers.utils.applyMethod(e, 'preventDefault', undefined, e);
          }
          if (that.hasClass('validate-wrapper')) {
            that.add(that.find('.validate-wrapper')).addClass('validate-wrapper-checked');
            if (PRIV.validation.passed.all(that, e)) {
              PRIV.validation.checked(e, options, that);
            } else {
              that.addClass('error-flag');
              that.trigger('ce.form.verify', [e, options]);
            }
          } else {
            var wrapper = that.closest('.validate-wrapper');
            if (wrapper.hasClass('validate-wrapper-checked')) {
              var valid = {
                text: that.hasClass('validate-text') ? PRIV.validation.passed.text(that, e) : true,
                email: that.hasClass('validate-email') ? PRIV.validation.passed.email(that, e) : true,
                url: that.hasClass('validate-url') ? PRIV.validation.passed.url(that, e) : true,
                slug: that.hasClass('validate-slug') ? PRIV.validation.passed.slug(that, e) : true,
                json: that.hasClass('validate-json') ? PRIV.validation.passed.json(that, e) : true,
                number: that.hasClass('validate-number') ? PRIV.validation.passed.number(that, e) : true,
                phone: that.hasClass('validate-phone') ? PRIV.validation.passed.phone(that, e) : true,
                password: that.hasClass('validate-password') ? PRIV.validation.passed.password(that, e) : true,
                textarea: that.hasClass('validate-textarea') ? PRIV.validation.passed.textarea(that, e) : true,
                date: that.hasClass('validate-date') ? PRIV.validation.passed.date(that, e) : true,
                time: that.hasClass('validate-time') ? PRIV.validation.passed.time(that, e) : true,
                checkbox: that.hasClass('validate-checkbox') ? PRIV.validation.passed.checkbox(that, e) : true,
                radio: that.hasClass('validate-radio') ? PRIV.validation.passed.radio(that, e) : true,
                select: that.hasClass('validate-select') ? PRIV.validation.passed.select(that, e) : true,
                file: that.hasClass('validate-file') ? PRIV.validation.passed.file(that, e) : true
              };
              var error = false;
              for (var key in valid) {
                if (!gv(valid, key)) {
                  error = true;
                }
              }
              if (error || gl(wrapper.find('.error-flag'))) {
                wrapper.addClass('error-flag');
                π.helpers.utils.applyMethod(e, 'preventDefault', undefined, e);
              } else {
                wrapper.removeClass('error-flag');
              }
              wrapper.trigger('ce.form.verify', [e, options]);
            }
          }
        },
        checked: function checked(e, options, that) {
          if (gv(e, 'originalEvent', false) || gv(options, 'isTriggered', false)) {
            if (that.data('helper-loading')) {
              π.helpers.loading.show();
            }
            π.helpers.captcha.setToken(function () {
              that.removeClass('error-flag');
              that.trigger('ce.form.verify', [e, options]);
              if (!that.hasClass('ajax-form') && !that.hasClass('custom-submit')) {
                that.submit();
              }
            });
          } else if (gv(options, 'isVerifying', false)) {
            that.removeClass('error-flag');
            that.trigger('ce.form.verify', [e, options]);
          }
        },
        toggle: function toggle(that, valid) {
          if (valid) {
            if (that.is('textarea') && that.prev().hasClass('mce-tinymce')) {
              that.removeClass('error-flag').prev().removeClass('error-flag');
            } else if (!that.hasClass('form-box') && gl(that.closest('.form-box'))) {
              that.closest('.form-box').removeClass('error-flag');
            } else {
              that.removeClass('error-flag');
            }
          } else {
            if (that.is('textarea') && that.prev().hasClass('mce-tinymce')) {
              that.addClass('error-flag').prev().addClass('error-flag');
            } else if (!that.hasClass('form-box') && gl(that.closest('.form-box'))) {
              that.closest('.form-box').addClass('error-flag');
            } else {
              that.addClass('error-flag');
            }
          }
        },
        setError: function setError(that, key, text) {
          that.data('validation-errors', π.helpers.data.setValue(that.data('validation-errors') || {}, key, text));
        },
        getError: function getError(that, key) {
          return gv(that.data('validation-errors'), key, false);
        },
        getScope: function getScope(that, name) {
          var scope = that.closest('.validate-' + name + '-scope');
          if (!gl(scope)) {
            scope = that.closest('.validate-wrapper');
          }
          return scope;
        },
        getDataNumber: function getDataNumber(that, key) {
          var val = that.data(key);
          return !isNaN(val) && val !== '' ? Number(val) : NaN;
        },
        // objects
        preprocess: {
          init: function init() {
            π.main.refs.body.on({
              'keyup.validate-wrapper.preprocess-text': PRIV.validation.preprocess.run
            }, '.validate-wrapper .validate-text, .validate-wrapper .validate-slug');
            π.main.refs.body.on({
              'blur.validate-wrapper.preprocess-text': PRIV.validation.preprocess.run
            }, '.validate-wrapper .validate-text, .validate-wrapper .validate-slug');
          },
          run: function run() {
            var that = $(this);
            PRIV.validation.preprocess.prepend(that);
            PRIV.validation.preprocess.append(that);
            PRIV.validation.preprocess.remove(that);
            PRIV.validation.preprocess.keep(that);
          },
          prepend: function prepend(that) {
            var val = that.val(),
              prepend = that.data('prepend');
            if (val && prepend) {
              that.val(prepend + val.replace(new RegExp('^' + _.escapeRegExp(prepend)), ''));
            }
          },
          append: function append(that) {
            var val = that.val(),
              append = that.data('append');
            if (val && append) {
              that.val(val.replace(new RegExp(_.escapeRegExp(append) + '$'), '') + append);
            }
          },
          remove: function remove(that) {
            var val = that.val(),
              remove = that.data('remove');
            if (val && remove && val.match(new RegExp(remove))) {
              var selectionStart = gv(that[0], 'selectionStart') - 1;
              that.val(val.replace(new RegExp(remove), ''));
              that[0].setSelectionRange(selectionStart, selectionStart);
            }
          },
          keep: function keep(that) {
            var val = that.val(),
              keep = that.data('keep');
            if (val && keep) {
              var value = val.match(new RegExp(keep, 'g')).join('');
              if (value != val) {
                var selectionStart = gv(that[0], 'selectionStart') - 1;
                that.val(value);
                that[0].setSelectionRange(selectionStart, selectionStart);
              }
            }
          }
        },
        passed: {
          all: function all(wrapper, e, options) {
            var valid = true;
            _.each(['text', 'email', 'url', 'slug', 'json', 'number', 'phone', 'password', 'date', 'time', 'textarea', 'checkbox', 'radio', 'select', 'file'], function (key) {
              if (!PRIV.validation.passed[key](wrapper, e, options)) {
                valid = false;
              }
            });
            return valid;
          },
          loop: function loop(that, key, e, options) {
            var valid = true;
            that.find('.validate-' + key).each(function () {
              if (!PRIV.validation.passed[key]($(this), e, options)) {
                valid = false;
              }
            });
            return valid;
          },
          chars: function chars(that, e) {
            var chars = that.data('chars'),
              valid = !chars || that.val().match(new RegExp('^[' + chars + ']*$'));
            if (!valid) {
              PRIV.validation.setError(that, 'characters.allowed', chars);
            }
            return valid;
          },
          regex: function regex(that, e) {
            var regex = that.data('regex'),
              valid = regex === undefined || π.helpers.data.isRegExMatch(that.val(), regex);
            if (!valid) {
              PRIV.validation.setError(that, 'regex.allowed', regex);
            }
            return valid;
          },
          length: function length(that, e) {
            var isOnBlur = gv(e, 'handleObj.origType', false) == 'blur',
              valTrimmed = _.trim(that.val()),
              val = isOnBlur ? that.val(valTrimmed).val() : valTrimmed,
              length = gv(that[0], 'type') == 'number' ? val : gl(val),
              opt = that.data('opt'),
              min = PRIV.validation.getDataNumber(that, 'min'),
              max = PRIV.validation.getDataNumber(that, 'max'),
              minError = (!opt || opt && length > 0) && (length < min || isNaN(min) && length === 0),
              maxError = length > max;
            if (minError) {
              if (gv(that[0], 'type') == 'number') {
                PRIV.validation.setError(that, 'length.min', !isNaN(min) ? min : 1);
              } else {
                PRIV.validation.setError(that, 'length.min-chars', !isNaN(min) ? min : 1);
              }
            } else if (maxError) {
              if (gv(that[0], 'type') == 'number') {
                PRIV.validation.setError(that, 'length.max', max);
              } else {
                PRIV.validation.setError(that, 'length.max-chars', max);
              }
            }
            return !minError && !maxError;
          },
          words: function words(that, e) {
            var length = gl(_.words(that.val())),
              opt = that.data('opt'),
              min = PRIV.validation.getDataNumber(that, 'min-words'),
              max = PRIV.validation.getDataNumber(that, 'max-words'),
              minError = !opt && (length < min || min === undefined && length <= 0),
              maxError = length > max;
            if (minError) {
              PRIV.validation.setError(that, 'length.min-words', typeof min == 'number' ? min : 1);
            } else if (maxError) {
              PRIV.validation.setError(that, 'length.max-words', max);
            }
            return !minError && !maxError;
          },
          completed: function completed(that, e) {
            var min = that.data('min');
            return (that.data('opt') || Number(min != '' ? min : undefined) === 0) && gl(that.val()) === 0;
          },
          extension: function extension(that, name, valid, completed, e, options) {
            if (π.helpers.data.isFunction(π, 'app.mixins.form._ext.validation.' + name)) {
              return π.app.mixins.form._ext.validation[name](that, valid, completed, e, options);
            } else {
              return valid;
            }
          },
          text: function text(that, e, options) {
            var valid = true;
            if (that.hasClass('validate-wrapper')) {
              valid = PRIV.validation.passed.loop(that, 'text', e, options);
            } else {
              var completed = PRIV.validation.passed.completed(that, e);
              that.data('validation-errors', null);
              if (!completed) {
                valid = PRIV.validation.passed.length(that, e);
                valid = PRIV.validation.passed.chars(that, e) && valid;
                valid = PRIV.validation.passed.regex(that, e) && valid;
              }
              valid = PRIV.validation.passed.extension(that, 'text', valid, completed, e, options);
              if (gv(options, 'toggle', false) !== false) {
                PRIV.validation.toggle(that, valid);
              }
            }
            return valid;
          },
          email: function email(that, e, options) {
            var valid = true,
              match;
            if (that.hasClass('validate-wrapper')) {
              valid = PRIV.validation.passed.loop(that, 'email', e, options);
            } else {
              π.app.mixins.form.setToLowerCase(that);
              var completed = PRIV.validation.passed.completed(that, e),
                val = that.val();
              that.data('validation-errors', null);
              if (!completed) {
                valid = PRIV.validation.passed.length(that, e);
                if (!validator.isEmail(val)) {
                  valid = false;
                  PRIV.validation.setError(that, 'characters.format', 'not valid');
                }
              }
              valid = PRIV.validation.passed.extension(that, 'email', valid, completed, e, options);
              if (gv(options, 'toggle', false) !== false) {
                PRIV.validation.toggle(that, valid);
              }
            }
            return valid;
          },
          url: function url(that, e, options) {
            var valid = true;
            if (that.hasClass('validate-wrapper')) {
              valid = PRIV.validation.passed.loop(that, 'url', e, options);
            } else {
              π.app.mixins.form.setToLowerCase(that);
              var completed = PRIV.validation.passed.completed(that, e),
                val = that.val();
              that.data('validation-errors', null);
              if (!completed) {
                valid = PRIV.validation.passed.length(that, e);
                if (!validator.isURL(val, {
                  'require_protocol': true
                })) {
                  valid = false;
                  PRIV.validation.setError(that, 'characters.format', 'not valid');
                }
              }
              valid = PRIV.validation.passed.extension(that, 'url', valid, completed, e, options);
              if (gv(options, 'toggle', false) !== false) {
                PRIV.validation.toggle(that, valid);
              }
            }
            return valid;
          },
          slug: function slug(that, e, options) {
            var valid = true,
              match;
            if (that.hasClass('validate-wrapper')) {
              valid = PRIV.validation.passed.loop(that, 'slug', e, options);
            } else {
              var completed = PRIV.validation.passed.completed(that, e),
                val = that.val();
              that.data('validation-errors', null);
              if (!completed) {
                valid = PRIV.validation.passed.length(that, e);
                valid = (match = val.match(/^\/[a-z0-9-\/]*$/) !== null) && valid;
                if (!match) {
                  PRIV.validation.setError(that, 'characters.allowed', '[a-z0-9-\/]');
                }
              }
              valid = PRIV.validation.passed.extension(that, 'slug', valid, completed, e, options);
              if (gv(options, 'toggle', false) !== false) {
                PRIV.validation.toggle(that, valid);
              }
            }
            return valid;
          },
          json: function json(that, e, options) {
            var valid = true;
            if (that.hasClass('validate-wrapper')) {
              valid = PRIV.validation.passed.loop(that, 'json', e, options);
            } else {
              var completed = PRIV.validation.passed.completed(that, e),
                val = that.val();
              if (!completed) {
                valid = PRIV.validation.passed.length(that, e);
                valid = valid ? _.isString(val) : valid;
                valid = valid ? validator.isJSON(val) : valid;
              }
              valid = PRIV.validation.passed.extension(that, 'json', valid, completed, e, options);
              if (gv(options, 'toggle', false) !== false) {
                PRIV.validation.toggle(that, valid);
              }
            }
            return valid;
          },
          number: function number(that, e, options) {
            var valid = true;
            if (that.hasClass('validate-wrapper')) {
              valid = PRIV.validation.passed.loop(that, 'number', e, options);
            } else {
              var completed = PRIV.validation.passed.completed(that, e);
              that.data('validation-errors', null);
              if (!completed) {
                valid = PRIV.validation.passed.length(that, e);
                valid = PRIV.validation.passed.regex(that, e) && valid;
              }
              valid = PRIV.validation.passed.extension(that, 'number', valid, completed, e, options);
              if (gv(options, 'toggle', false) !== false) {
                PRIV.validation.toggle(that, valid);
              }
            }
            return valid;
          },
          phone: function phone(that, e, options) {
            var valid = true;
            if (that.hasClass('validate-wrapper')) {
              valid = PRIV.validation.passed.loop(that, 'phone', e, options);
            } else {
              var completed = PRIV.validation.passed.completed(that, e);
              that.data('validation-errors', null);
              if (!completed) {
                valid = π.helpers.data.isRegExMatch(that.val(), '^(\\+|0)[0-9\\-\\/()\\s]{5,30}$');
              }
              valid = PRIV.validation.passed.extension(that, 'phone', valid, completed, e, options);
              if (gv(options, 'toggle', false) !== false) {
                PRIV.validation.toggle(that, valid);
              }
            }
            return valid;
          },
          password: function password(that, e, options) {
            var valid = true,
              match,
              equal;
            if (that.hasClass('validate-wrapper')) {
              valid = PRIV.validation.passed.loop(that, 'password', e, options);
            } else {
              var completed = PRIV.validation.passed.completed(that, e),
                scope = PRIV.validation.getScope(that, 'password'),
                passwords = scope.find('.validate-password'),
                val = that.val();
              that.data('validation-errors', null);
              if (!completed) {
                valid = PRIV.validation.passed.length(that, e);
                valid = PRIV.validation.passed.chars(that, e) && valid;
                valid = PRIV.validation.passed.regex(that, e) && valid;
                if (that.data('contain-number')) {
                  valid = (match = val.match(/[0-9]/g) !== null) && valid;
                  if (!match) {
                    PRIV.validation.setError(that, 'characters.number', 'missing');
                  }
                }
                if (that.data('contain-uplow')) {
                  valid = (match = val.match(/[A-Z]/g) !== null) && valid;
                  if (!match) {
                    PRIV.validation.setError(that, 'characters.upper-case', 'missing');
                  }
                  valid = (match = val.match(/[a-z]/g) !== null) && valid;
                  if (!match) {
                    PRIV.validation.setError(that, 'characters.lower-case', 'missing');
                  }
                }
                if (that.data('contain-special')) {
                  valid = (match = val.match(/[\^°!"§$%&\/()=?´`\[\]|{}€+*@#'<>,;.:\-_~]/g) !== null) && valid;
                  if (!match) {
                    PRIV.validation.setError(that, 'characters.special-sign', 'missing');
                  }
                }
                if (gl(passwords) > 1) {
                  passwords.each(function () {
                    if (!$(this).is(that) && gv(this, 'name') == that.attr('name')) {
                      var sibling = $(this);
                      valid = (equal = sibling.val() == val) && valid;
                      if (!equal) {
                        PRIV.validation.setError(that, 'revision', 'not equal');
                        if (!PRIV.validation.getError(sibling, 'revision')) {
                          PRIV.validation.passed.password(sibling, e);
                        }
                      } else if (PRIV.validation.getError(sibling, 'revision')) {
                        PRIV.validation.passed.password(sibling, e);
                      }
                    }
                  });
                }
              }
              valid = PRIV.validation.passed.extension(that, 'password', valid, completed, e, options);
              if (gv(options, 'toggle', false) !== false) {
                passwords.each(function () {
                  PRIV.validation.toggle($(this), valid);
                });
              }
            }
            return valid;
          },
          textarea: function textarea(that, e, options) {
            var valid = true;
            if (that.hasClass('validate-wrapper')) {
              valid = PRIV.validation.passed.loop(that, 'textarea', e, options);
            } else {
              var completed = PRIV.validation.passed.completed(that, e);
              if (!completed) {
                valid = PRIV.validation.passed.length(that, e);
                valid = PRIV.validation.passed.words(that, e) && valid;
              }
              valid = PRIV.validation.passed.extension(that, 'textarea', valid, completed, e, options);
              if (gv(options, 'toggle', false) !== false) {
                PRIV.validation.toggle(that, valid);
              }
            }
            return valid;
          },
          checkbox: function checkbox(that, e, options) {
            var valid = true;
            if (that.hasClass('validate-wrapper')) {
              valid = PRIV.validation.passed.loop(that, 'checkbox', e, options);
            } else {
              var scope = PRIV.validation.getScope(that, 'checkbox');
              valid = false;
              scope.find('input[type=checkbox]').each(function () {
                var that = $(this);
                if (that.prop('checked')) {
                  that.attr('checked', 'checked');
                  valid = true;
                } else {
                  that.removeAttr('checked');
                }
              });
              if (gv(options, 'toggle', false) !== false) {
                scope.find('input[type=checkbox]').each(function () {
                  PRIV.validation.toggle($(this), valid);
                });
              }
              valid = PRIV.validation.passed.extension(that, 'checkbox', valid, undefined, e, options);
              if (gv(options, 'toggle', false) !== false) {
                PRIV.validation.toggle(that, valid);
              }
            }
            return valid;
          },
          radio: function radio(that, e, options) {
            var valid = true;
            if (that.hasClass('validate-wrapper')) {
              valid = PRIV.validation.passed.loop(that, 'radio', e, options);
            } else {
              var scope = PRIV.validation.getScope(that, 'radio');
              valid = false;
              scope.find('input[type=radio]').each(function () {
                var that = $(this);
                if (that.prop('checked')) {
                  that.attr('checked', 'checked');
                  valid = true;
                } else {
                  that.removeAttr('checked');
                }
              });
              if (gv(options, 'toggle', false) !== false) {
                scope.find('input[type=radio]').each(function () {
                  PRIV.validation.toggle($(this), valid);
                });
              }
              valid = PRIV.validation.passed.extension(that, 'radio', valid, undefined, e, options);
              if (gv(options, 'toggle', false) !== false) {
                PRIV.validation.toggle(that, valid);
              }
            }
            return valid;
          },
          select: function select(that, e, options) {
            var valid = true;
            if (that.hasClass('validate-wrapper')) {
              valid = PRIV.validation.passed.loop(that, 'select', e, options);
            } else {
              var val = that.val(),
                maxTags = that.data('max-tags'),
                minTags = that.data('min-tags');
              valid = that.data('opt') || val && gl(val) ? true : false;
              valid = PRIV.validation.passed.extension(that, 'select', valid, undefined, e);
              valid = valid && (isNaN(minTags) || !_.isArray(val) || gl(val) >= minTags);
              valid = valid && (isNaN(maxTags) || !_.isArray(val) || gl(val) <= maxTags);
              _.each(_.castArray(val), function (val) {
                var min = PRIV.validation.getDataNumber(that, 'min-chars'),
                  max = PRIV.validation.getDataNumber(that, 'max-chars');
                valid = valid && (isNaN(min) || gl(val) >= min) && (isNaN(max) || gl(val) <= max);
                if (valid) {
                  var chars = that.data('chars');
                  valid = valid && (typeof chars != 'string' || val.match(new RegExp('^[' + chars + ']*$')) !== null);
                }
              });
              if (gv(options, 'toggle', false) !== false) {
                if (valid) {
                  that.next().removeClass('error-flag');
                } else {
                  that.next().addClass('error-flag');
                }
              }
            }
            return valid;
          },
          file: function file(that, e, options) {
            var valid = true;
            if (that.hasClass('validate-wrapper')) {
              valid = PRIV.validation.passed.loop(that, 'file', e, options);
            } else {
              var completed = that.data('opt') !== undefined;
              that.data('validation-errors', null);
              if (!completed) {
                valid = gl(that.val()) > 0;
              }
              valid = PRIV.validation.passed.extension(that, 'file', valid, completed, e, options);
              if (gv(options, 'toggle', false) !== false) {
                PRIV.validation.toggle(that, valid);
              }
            }
            return valid;
          },
          date: function date(that, e, options) {
            var valid = true;
            if (that.hasClass('validate-wrapper')) {
              valid = PRIV.validation.passed.loop(that, 'date', e, options);
            } else {
              var completed = PRIV.validation.passed.completed(that, e);
              that.data('validation-errors', null);
              if (!completed) {
                var val = that.val(),
                  min = that.data('min'),
                  max = that.data('max');
                valid = (!min || new Date(val) > new Date(min)) && valid;
                valid = (!max || new Date(val) < new Date(max)) && valid;
              }
              valid = PRIV.validation.passed.extension(that, 'date', valid, completed, e, options);
              if (gv(options, 'toggle', false) !== false) {
                PRIV.validation.toggle(that, valid);
              }
            }
            return valid;
          },
          time: function time(that, e, options) {
            var valid = true;
            if (that.hasClass('validate-wrapper')) {
              valid = PRIV.validation.passed.loop(that, 'time', e, options);
            } else {
              var completed = PRIV.validation.passed.completed(that, e);
              that.data('validation-errors', null);
              if (!completed) {
                var val = that.val(),
                  min = that.data('min'),
                  max = that.data('max');
                valid = (!min || Number(val.replace(':', '')) > Number(min.replace(':', ''))) && valid;
                valid = (!max || Number(val.replace(':', '')) < Number(max.replace(':', ''))) && valid;
              }
              valid = PRIV.validation.passed.extension(that, 'time', valid, completed, e, options);
              if (gv(options, 'toggle', false) !== false) {
                PRIV.validation.toggle(that, valid);
              }
            }
            return valid;
          }
        },
        status: {
          init: function init() {
            π.main.refs.body.find('.validation-status:not(.initialized-validation-status)').each(function () {
              PRIV.validation.status.update($(this).addClass('initialized-validation-status').on({
                'blur': PRIV.validation.status.onBlur,
                'change': PRIV.validation.status.onChange,
                'keydown': PRIV.validation.status.onKeyDown
              }));
            });
          },
          promise: function promise(that) {
            if (!that.data('validation-status')) {
              var id = π.helpers.utils.getUniqueId(),
                html = '<div id="' + id + '" class="validation-status-wrapper">' + PRIV.validation.status.getHTML(that) + '</div>';
              that.parent().append(html);
              that.data('validation-status', π.main.refs.body.find('#' + id));
              if (that.hasClass('language-field')) {
                var name = that.attr('name');
                that.data('validation-status').addClass('language-field').addClass('language-' + name.slice(name.lastIndexOf('.') + 1));
                if (that.hasClass('language-hide')) {
                  that.data('validation-status').addClass('language-hide');
                }
              }
            }
            return that;
          },
          update: function update(that) {
            setTimeout(function () {
              if (gl(that) === 1 && π.helpers.data.isJQueryObject(that.data('validation-status'))) {
                that.data('validation-status').html(PRIV.validation.status.getHTML(that));
              } else {
                that.each(function () {
                  PRIV.validation.status.update(PRIV.validation.status.promise($(this)));
                });
              }
            }, 1);
          },
          getHTML: function getHTML(that) {
            PRIV.validation.passed.password(that, undefined, {
              'toggle': false
            });
            var validationErrorsFlatten = π.helpers.data.getObjectFlatted(that.data('validation-errors'));
            that.data('validation-rules', _.merge(that.data('validation-rules'), validationErrorsFlatten));
            var html = '';
            _.each(that.data('validation-rules'), function (value, key) {
              if (gv(validationErrorsFlatten, key, false)) {
                if (π.helpers.data.isFunction(π, 'app.mixins.form._ext.validation.status.getError')) {
                  html += π.app.mixins.form._ext.validation.status.getError(key, value);
                } else {
                  html += '<span>✗ ' + key + ': ' + value + '</span>';
                }
              } else {
                if (π.helpers.data.isFunction(π, 'app.mixins.form._ext.validation.status.getSuccess')) {
                  html += π.app.mixins.form._ext.validation.status.getSuccess(key, value);
                } else {
                  html += '<span>✓ ' + key + ': ' + value + '</span>';
                }
              }
            });
            return html;
          },
          onBlur: function onBlur() {
            PRIV.validation.status.update($(this));
          },
          onChange: function onChange() {
            PRIV.validation.status.update($(this));
          },
          onKeyDown: function onKeyDown() {
            PRIV.validation.status.update($(this));
          }
        }
      },
      text: {
        init: function init() {
          π.main.refs.body.on({
            'focus': PRIV.text.onFocusUnchangeable
          }, 'input.unchangeable[type=text]');
        },
        onFocusUnchangeable: function onFocusUnchangeable() {
          this.blur();
        }
      },
      select: {
        init: function init(that) {
          var forceInit = π.helpers.data.isJQueryObject(that);
          (that || π.main.refs.body.find('form select:not(.initialized-select)')).each(function () {
            that = $(this);
            if ((!that.hasClass('no-select2') || forceInit) && !that.hasClass('initialized-select')) {
              var width = window.getComputedStyle(that[0], null).getPropertyValue('width'),
                minWidth = that.css('min-width'),
                options = {
                  'escapeMarkup': function escapeMarkup(text) {
                    return text;
                  },
                  'theme': 'classic',
                  'width': 'no'
                };
              if (width != '100%') {
                _.set(options, 'width', width);
              }
              if (that.hasClass('no-search')) {
                _.set(options, 'minimumResultsForSearch', -1);
              }
              if (that.hasClass('tags')) {
                _.set(options, 'tags', true);
                _.set(options, 'tokenSeparators', [',', ' ']);
              }
              if (that.hasClass('crop-text')) {
                _.set(options, 'dropdownCssClass', 'select2-crop-text');
              }
              if (that.data('max')) {
                _.set(options, 'maximumSelectionLength', that.data('max'));
              }
              if (that.data('placeholder')) {
                _.set(options, 'placeholder', String(that.data('placeholder')));
                _.set(options, 'allowClear', true);
              }
              that.data('select2-event-handlers', {
                'select2:opening': PRIV.select.onOpening,
                'select2:open': PRIV.select.onOpen,
                'select2:close': PRIV.select.onClose,
                'select2:select': PRIV.select.onSelect,
                'select2:unselect': PRIV.select.onUnselect
              });
              that.addClass('initialized-select').select2(options).on(that.data('select2-event-handlers'));
              that.data('select2-ui-element', that.next());
              that.data('select2-ui-element').data('select2-root-element', that);
              that.data('select2-ui-element').on({
                'focus': PRIV.select.onFocus
              }, '.select2-search__field');
              if (that.hasClass('not-selectable')) {
                that.data('select2-ui-element').addClass('select2-not-selectable');
              }
              if (that.hasClass('not-removable')) {
                that.data('select2-ui-element').find('.select2-selection__rendered').addClass('select2-not-removable');
              }
              if (that.attr('multiple') && that.data('sortable')) {
                that.data('select2-ui-element').find('.select2-selection__rendered').sortable({
                  'items': 'li:not(.select2-search)',
                  'update': PRIV.select.onSort
                });
              }
              if (minWidth) {
                that.data('select2-ui-element').css({
                  'min-width': minWidth
                });
              }
              if (that.data('focus')) {
                that.removeAttr('data-focus').select2('focus');
              }
              PRIV.select.addLinks(that);
              PRIV.select.copyStyleSelected(that);
              that.trigger('ce.form.select2.init');
            }
          });
        },
        close: function close(that) {
          that.each(function () {
            var that = $(this);
            if (that.hasClass('initialized-select')) {
              that.select2('close');
            }
          });
        },
        destroy: function destroy(that) {
          var classes = 'initialized-select select2-hidden-accessible',
            attributes = 'data-select2-id tabindex aria-hidden';
          that.each(function () {
            var that = $(this);
            if (that.hasClass('initialized-select')) {
              _.each(that.data('select2-event-handlers'), function (value, key) {
                that.off(key, value);
              });
              if (that.data('select2')) {
                that.select2('destroy');
              }
              that.parent().find('.select2').remove();
              that.find('option[data-select2-id]').removeAttr('data-select2-id');
            }
          }).removeClass(classes).removeAttr(attributes);
        },
        addLinks: function addLinks(that) {
          if (that.attr('multiple')) {
            var select2Items = that.data('select2-ui-element').find('.select2-selection__choice:not(.ui-sortable-placeholder)');
            that.find('option[data-link-href]').each(function () {
              var that = $(this),
                text = that.text(),
                href = that.data('link-href');
              select2Items.each(function () {
                var that = $(this);
                if (gv(this, 'title') == text && !gl(that.find('a'))) {
                  var html = that.html(),
                    link = '<a href="' + href + '">' + text + '</a>';
                  that.html(html.replace(new RegExp(text + '$'), link));
                  that.find('a').on({
                    'click': PRIV.select.onClickLink
                  });
                }
              });
            });
          }
        },
        copyStyleSelected: function copyStyleSelected(that) {
          var style = that.find('option[selected][style]').attr('style');
          if (style) {
            that.data('select2-ui-element').find('.select2-selection__rendered').attr('style', style);
          } else {
            that.data('select2-ui-element').find('.select2-selection__rendered').removeAttr('style');
          }
        },
        setStyleSelected: function setStyleSelected(that) {
          var style = that.find('option[value="' + that.val() + '"]').attr('style');
          if (style) {
            that.data('select2-ui-element').find('.select2-selection__rendered').attr('style', style);
          } else {
            that.data('select2-ui-element').find('.select2-selection__rendered').removeAttr('style');
          }
        },
        setStyleOptions: function setStyleOptions(that) {
          π.main.refs.body.find('.select2-results__option').each(function () {
            var value = gv(this, 'id').slice(gv(this, 'id').lastIndexOf('-') + 1);
            $(this).attr('style', that.find('option[value="' + value + '"]').attr('style'));
          });
        },
        setSelected: function setSelected(that) {
          if (that.attr('multiple') && that.data('sortable')) {
            var values = _.castArray(that.val());
            that.data('select2-ui-element').find('.select2-selection__rendered').sortable('refresh');
            that.find('option').each(function () {
              var that = $(this);
              if (values.includes(gv(this, 'value'))) {
                that.attr('selected', 'selected');
              } else {
                that.removeAttr('selected');
              }
            });
          }
        },
        onFocus: function onFocus(e) {
          var that = $(this);
          if (that.closest('.select2').hasClass('select2-not-selectable')) {
            this.blur();
          }
        },
        onOpening: function onOpening(e) {
          var that = $(this);
          if (that.data('isUnselected')) {
            e.preventDefault();
            that.removeData('isUnselected');
          } else if (that.hasClass('not-selectable')) {
            e.preventDefault();
          }
        },
        onOpen: function onOpen(e) {
          var that = $(this).trigger('ce.form.select2.open');
          setTimeout(function () {
            that.data('scroll-lock-exception', π.main.refs.body.find('.select2-results__options'));
            π.helpers.scroll.addScrollLockExceptions(that.data('scroll-lock-exception'));
            π.main.refs.body.find('.select2-search__field').off('input').on({
              'input': function input(e) {
                return PRIV.select.setStyleOptions(that);
              }
            });
            PRIV.select.setStyleOptions(that);
          }, 10);
        },
        onClose: function onClose(e) {
          var that = $(this).trigger('ce.form.select2.close');
          π.helpers.scroll.removeScrollLockExceptions(that.data('scroll-lock-exception'));
        },
        onSelect: function onSelect(e) {
          var that = $(this);
          PRIV.select.onUpdate.apply(this, [e]);
          if (that.data('query')) {
            π.helpers.url.historyPushState(_.merge(π.helpers.url.getQueryObject(), _defineProperty({}, gv(this, 'name'), that.val())));
            location.reload();
          }
          that.trigger('ce.form.select2.select');
        },
        onUnselect: function onUnselect(e) {
          PRIV.select.onUpdate.apply(this, [e]);
          $(this).data('isUnselected', true).trigger('ce.form.select2.unselect');
        },
        onSort: function onSort(e) {
          var that = $(this),
            select = $(that.data('select2-root-element')),
            options = select.find('option'),
            values = _.castArray(select.val()),
            wrapper = $(document.createElement('div'));
          that.find('.select2-selection__choice:not(.ui-sortable-placeholder)').each(function () {
            var title = gv(this, 'title');
            options.each(function () {
              var that = $(this);
              if (title == that.text()) {
                wrapper.append(that.clone().attr('selected', 'selected'));
              }
            });
          });
          select.find('option').each(function () {
            if (!values.includes(gv(this, 'value'))) {
              if (gl(this, 'value')) {
                wrapper.append($(this).clone());
              } else {
                wrapper.prepend($(this).clone());
              }
            }
          });
          π.app.mixins.form.select.destroy(select);
          PRIV.select.init(select.html(wrapper.html()));
          PRIV.select.onUpdate.apply(select, [e]);
          select.trigger('ce.form.select2.sort');
        },
        onUpdate: function onUpdate(e) {
          var that = $(this);
          PRIV.select.setSelected(that);
          PRIV.select.setStyleSelected(that);
          PRIV.select.addLinks(that);
        },
        onClickLink: function onClickLink(e) {
          e.stopPropagation();
        }
      },
      checkbox: {
        init: function init() {
          π.main.refs.body.on({
            'change': PRIV.checkbox.onChange
          }, 'input[type=checkbox]');
        },
        onChange: function onChange() {
          $(this).closest('form').find('input[type=checkbox][name="' + gv(this, 'name') + '"]').each(function () {
            var that = $(this);
            if (that.prop('checked')) {
              that.closest('.form-box.input-checkbox').addClass('input-checkbox-checked');
            } else {
              that.closest('.form-box.input-checkbox').removeClass('input-checkbox-checked');
            }
          });
        }
      },
      radio: {
        init: function init() {
          π.main.refs.body.on({
            'change': PRIV.radio.onChange
          }, 'input[type=radio]');
        },
        onChange: function onChange() {
          $(this).closest('form').find('input[type=radio][name="' + gv(this, 'name') + '"]').each(function () {
            var that = $(this);
            if (that.prop('checked')) {
              that.closest('.form-box.input-radio').addClass('input-radio-checked');
            } else {
              that.closest('.form-box.input-radio').removeClass('input-radio-checked');
            }
          });
        }
      },
      file: {
        init: function init() {
          π.main.refs.body.on({
            'click': PRIV.file.onClickChoose
          }, '.input-file .btn');
          π.main.refs.body.on({
            'change': PRIV.file.onChange
          }, '.input-file input[type=file]');
        },
        hasValidDimensions: function hasValidDimensions(e, file, wrapper, callback) {
          var width = wrapper.data('width'),
            height = wrapper.data('height'),
            minWidth = wrapper.data('min-width'),
            minHeight = wrapper.data('min-height'),
            maxWidth = wrapper.data('max-width'),
            maxHeight = wrapper.data('max-height');
          if (width || height || minWidth || minHeight || maxWidth || maxHeight) {
            var img = new Image();
            img.onload = function () {
              if (width && gv(img, 'width') != width) {
                π.helpers.utils.applyMethod(callback, undefined, [{
                  'info': 'width should be ' + width
                }]);
              } else if (height && gv(img, 'height') != height) {
                π.helpers.utils.applyMethod(callback, undefined, [{
                  'info': 'height should be ' + height + 'px'
                }]);
              } else if (minWidth && gv(img, 'width') < minWidth) {
                π.helpers.utils.applyMethod(callback, undefined, [{
                  'info': 'min. width should be ' + minWidth + 'px'
                }]);
              } else if (minHeight && gv(img, 'height') < minHeight) {
                π.helpers.utils.applyMethod(callback, undefined, [{
                  'info': 'max. height should be ' + minHeight + 'px'
                }]);
              } else if (maxWidth && gv(img, 'width') > maxWidth) {
                π.helpers.utils.applyMethod(callback, undefined, [{
                  'info': 'min. width should be ' + maxWidth + 'px'
                }]);
              } else if (maxHeight && gv(img, 'height') > maxHeight) {
                π.helpers.utils.applyMethod(callback, undefined, [{
                  'info': 'max. height should be ' + maxHeight + 'px'
                }]);
              } else {
                π.helpers.utils.applyMethod(callback);
              }
            };
            _.set(img, 'src', gv(e, 'target.result'));
          } else {
            π.helpers.utils.applyMethod(callback);
          }
        },
        onClickChoose: function onClickChoose() {
          $(this).closest('.input-file').find('input[type=file]').trigger('click');
        },
        onChange: function onChange() {
          var that = $(this),
            wrapper = that.closest('.input-file');
          var info = '';
          if (gl(this, 'files')) {
            _.each(gv(this, 'files'), function (file) {
              info += gv(file, 'name') + ', ';
              var fileReader = new FileReader();
              fileReader.onload = function (e) {
                return PRIV.file.onFileReaderLoad(e, file, wrapper);
              };
              fileReader.readAsDataURL(file);
            });
            wrapper.find('.info').text(_.trimEnd(info, ', ')).removeClass('error');
          }
        },
        onFileReaderLoad: function onFileReaderLoad(e, file, wrapper) {
          PRIV.file.hasValidDimensions(e, file, wrapper, function (err) {
            if (err) {
              wrapper.find('.info').text(gv(err, 'info')).addClass('error');
            } else {
              if (wrapper.hasClass('base64') && gv(file, 'size') < 100000) {
                wrapper.find('input[type=hidden]').attr('value', gv(e, 'target.result'));
              }
              wrapper.find('img').attr('src', gv(e, 'target.result'));
              π.helpers.utils.applyMethod(π.app.mixins.fold, 'expand', [wrapper.closest('.fold-content')]);
            }
          });
        }
      }
    },
    _refs = {},
    _vars = {
      lastSubmit: undefined,
      captchaKeyRequestTime: undefined
    };

  // PUBLIC
  return {
    _refs: {},
    _vars: {},
    // methods
    init: function init() {
      PRIV.worker.init();
      PRIV.csrf.init();
      PRIV.ajax.init();
      PRIV.focus.init();
      PRIV.enter.init();
      PRIV.counter.init();
      PRIV.uniform.init();
      PRIV.validation.init();
      PRIV.text.init();
      PRIV.select.init();
      PRIV.checkbox.init();
      PRIV.radio.init();
      PRIV.file.init();
    },
    validate: function validate(that, options) {
      π.helpers.utils.applyMethod(PRIV, 'validation.check', [undefined, options], that[0]);
    },
    setToLowerCase: function setToLowerCase(that) {
      that.val(that.val().toLocaleLowerCase());
    },
    setPointerPosition: function setPointerPosition(that, pos) {
      if (that[0]) {
        that[0].setSelectionRange(pos, pos);
      }
    },
    getFormData: function getFormData(form) {
      if (gl(form)) {
        var wrapper = $(form),
          data = {};
        if (gl(wrapper.find('.form-array'))) {
          _.set(data, 'form-array', []);
          wrapper.find('.form-array').each(function (i) {
            gv(data, 'form-array').push(π.app.mixins.form.getFormData($(this)));
          });
        }
        wrapper.find('input[name], textarea[name]').each(function () {
          var that = $(this),
            type = that.attr('type'),
            name = that.attr('name'),
            isChecked = that.is(':checked');
          if (!gl(that.closest('.form-array')) || wrapper.hasClass('form-array')) {
            if (type != 'checkbox' && type != 'radio' || isChecked) {
              if (_.isString(data[name])) {
                data[name] = _.castArray(data[name]);
                data[name] = data[name].concat(that.val());
              } else if (_.isArray(data[name])) {
                data[name].push(that.val());
              } else {
                data[name] = that.val();
              }
            }
          }
        });
        wrapper.find('select[name]').each(function () {
          var that = $(this);
          if (!gl(that.closest('.form-array')) || wrapper.hasClass('form-array')) {
            data[that.attr('name')] = that.val();
          }
        });
        return wrapper.hasClass('ajax-true-type') ? π.app.mixins.form.payload.getTypes(data) : data;
      } else {
        return {};
      }
    },
    getFormValue: function getFormValue(that) {
      return gv(π.app.mixins.form.getFormData($('<form></form>').append(that.clone())), that.attr('name'), false);
    },
    onHTMLMutation: function onHTMLMutation() {
      PRIV.csrf.init();
      PRIV.focus.init();
      PRIV.counter.init();
      PRIV.select.init();
      PRIV.validation.status.init();
    },
    // objects
    select: {
      init: function init(that) {
        PRIV.select.init(that);
      },
      close: function close() {
        var that = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : π.main.refs.body.find('select');
        PRIV.select.close(that);
      },
      destroy: function destroy(that) {
        PRIV.select.destroy(that);
      }
    },
    payload: {
      getTypes: function getTypes(data) {
        var types = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['null', 'boolean', 'number', 'array', 'object'];
        _.each(_.castArray(types), function (type) {
          if (type === null || type == 'null') {
            data = π.app.mixins.form.payload.getNulls(data);
          } else if (type == 'boolean' || type == 'booleans') {
            data = π.app.mixins.form.payload.getBooleans(data);
          } else if (type == 'number') {
            data = π.app.mixins.form.payload.getNumbers(data);
          } else if (type == 'array') {
            data = π.app.mixins.form.payload.getArrays(data);
          } else if (type == 'object') {
            data = π.app.mixins.form.payload.getObjects(data);
          }
        });
        return data;
      },
      getNulls: function getNulls(data) {
        π.helpers.utils.runDataRecursive(data, function (node, key, value) {
          _.set(node, key, gv(node, key) == 'null' ? null : gv(node, key));
        });
        return data;
      },
      getBooleans: function getBooleans(data) {
        π.helpers.utils.runDataRecursive(data, function (node, key, value) {
          _.set(node, key, gv(node, key) == 'true' ? true : gv(node, key) == 'false' ? false : gv(node, key));
        });
        return data;
      },
      getNumbers: function getNumbers(data) {
        π.helpers.utils.runDataRecursive(data, function (node, key, value) {
          _.set(node, key, _.isString(gv(node, key)) && !isNaN(gv(node, key)) && gv(node, key) !== '' ? Number(gv(node, key)) : gv(node, key));
        });
        return data;
      },
      getArrays: function getArrays(data) {
        π.helpers.utils.runDataRecursive(data, function (node, key, value) {
          if (_.isString(gv(node, key)) && gv(node, key).startsWith('[') && gv(node, key).endsWith(']')) {
            _.set(node, key, gv(node, key).replace(/^\[/, '').replace(/\]$/, '').split(/,\s?/g));
            _.each(gv(node, key), function (item, i) {
              return _.set(item, i, gv(item, i).replace(/"/g, ''));
            });
          }
        });
        return data;
      },
      getObjects: function getObjects(data) {
        π.helpers.utils.runDataRecursive(data, function (node, key, value) {
          if (_.isString(gv(node, key)) && gv(node, key).startsWith('{') && gv(node, key).endsWith('}')) {
            _.set(node, key, lib.parse.json.getParsed(gv(node, key)));
          }
        });
        return data;
      }
    }
  };
}());;"use strict";

π.add('app.mixins.query', function () {
  // PRIVATE
  var CONF = {},
    PRIV = {
      getKeys: function getKeys(that) {
        var keys = [that.attr('name')];
        that.find('optgroup[data-value]').each(function () {
          keys.push($(this).data('value'));
        });
        if (!gl(keys)) {
          keys = [that.attr('name')];
        }
        return keys;
      },
      getSelectObject: function getSelectObject(that) {
        var vals = that.val(),
          select = {};
        that.find('option:selected').each(function () {
          var option = $(this),
            key = option.closest('optgroup').data('value') || that.attr('name');
          _.set(select, key, π.helpers.data.getExtendedRoot(gv(select, key, false), option.val()));
        });
        return _.sortByKeys(select);
      },
      onChangeSelect: function onChangeSelect() {
        var that = $(this);
        var url;
        if (!gl(that.closest('#overlay'))) {
          var query = _.merge(PRIV.getSelectObject(that), _.omit(π.helpers.url.getQueryObject(), PRIV.getKeys(that)));
          url = π.helpers.url.getQueryUrl(gv(location, 'href').split('?')[0], query, {
            isMultipleInstances: true
          });
          if (gv(location, 'href') !== url) {
            location.assign(url);
            setTimeout(function () {
              return that.select2('close');
            }, 1);
          }
        } else {
          var overlayUrl = gv(π, 'app.modules.overlay._refs.trigger').data('overlay-url'),
            overlayUrlInitial = gv(π, 'app.modules.overlay._refs.trigger').data('overlay-url-initial') || overlayUrl,
            _query = _.merge(PRIV.getSelectObject(that), _.omit(π.helpers.url.getQueryObject(overlayUrl), PRIV.getKeys(that)));
          url = π.helpers.url.getQueryUrl(overlayUrl.split('?')[0], _query, {
            isMultipleInstances: true
          });
          if (overlayUrl !== url) {
            gv(π, 'app.modules.overlay._refs.trigger').data('overlay-url', url).attr('data-overlay-url', url);
            gv(π, 'app.modules.overlay._refs.trigger').data('overlay-url-initial', overlayUrlInitial).attr('data-overlay-url-initial', overlayUrlInitial);
            setTimeout(function () {
              that.select2('close');
              π.app.modules.overlay.reload();
            }, 100);
          }
        }
      },
      onChangePage: function onChangePage() {
        var that = $(this),
          val = Number(that.val()),
          form = that.closest('form');
        form.find('.controls').removeClass('disabled');
        if (!this[val - 2]) {
          form.find('.prev').addClass('disabled');
        } else if (!this[val]) {
          form.find('.next').addClass('disabled');
        }
      },
      onClickReset: function onClickReset() {
        if (!gl($(this).closest('#overlay'))) {
          if (gv(location, 'href').includes('?')) {
            location.assign(gv(location, 'href').split('?')[0]);
          }
        } else {
          var overlayUrl = gv(π, 'app.modules.overlay._refs.trigger').data('overlay-url'),
            overlayUrlInitial = gv(π, 'app.modules.overlay._refs.trigger').data('overlay-url-initial') || overlayUrl,
            url = overlayUrl.split('?')[0];
          if (overlayUrl !== url) {
            gv(π, 'app.modules.overlay._refs.trigger').data('overlay-url', url).attr('data-overlay-url', url);
            gv(π, 'app.modules.overlay._refs.trigger').data('overlay-url-initial', overlayUrlInitial).attr('data-overlay-url-initial', overlayUrlInitial);
            π.app.modules.overlay.reload();
          }
        }
      }
    },
    _refs = {},
    _vars = {};

  // PUBLIC
  return {
    _refs: {},
    _vars: {},
    // methods
    init: function init() {
      π.main.refs.body.find('.mixin-query:not(.initialized-query)').each(function () {
        var that = $(this).addClass('initialized-query');
        that.find('select[name=page]').on({
          'change': PRIV.onChangePage
        });
        that.find('select').on({
          'change': PRIV.onChangeSelect
        });
        that.find('.reset').on({
          'click': PRIV.onClickReset
        });
      });
    },
    onHTMLMutation: function onHTMLMutation() {
      π.app.mixins.query.init();
    }
  };
}());;"use strict";

π.add('app.mixins.switcher', function () {
  // PRIVATE
  var CONF = {},
    PRIV = {
      setInitialValue: function setInitialValue() {
        π.main.refs.body.find('.mixin-switcher:not(.initialized-switcher)').each(function () {
          PRIV.setValue($(this).addClass('initialized-switcher'));
        });
      },
      setValue: function setValue(that) {
        var value = that.find('span.active').data('value');
        that.find('input').val(value);
        that.val(value);
      },
      onClick: function onClick() {
        var that = $(this),
          itemActive = that.find('span.active'),
          itemInactive = that.find('span:not(.active)');
        itemActive.removeClass('active');
        itemInactive.addClass('active');
        PRIV.setValue(that);
        that.trigger('ce.switcher.change');
      }
    },
    _refs = {},
    _vars = {};

  // PUBLIC
  return {
    _refs: {},
    _vars: {},
    // methods
    init: function init() {
      π.main.refs.body.on({
        'click': PRIV.onClick
      }, '.mixin-switcher.initialized-switcher');
    },
    onHTMLMutation: function onHTMLMutation() {
      PRIV.setInitialValue();
    }
  };
}());;"use strict";

π.add('app.mixins.togglePassword', function () {
  // PRIVATE
  var CONF = {},
    PRIV = {
      onClick: function onClick() {
        var that = $(this),
          icon = that.find('.icon'),
          inputPassword = that.closest('.row, .password-wrapper').find('input[type=password]'),
          inputText = that.closest('.row, .password-wrapper').find('input[type=text]');
        if (gl(inputPassword)) {
          icon.removeClass('icon-eye').addClass('icon-eye-closed');
          inputPassword.attr('type', 'text').focus();
        } else if (gl(inputText)) {
          icon.removeClass('icon-eye-closed').addClass('icon-eye');
          inputText.attr('type', 'password').focus();
        }
      }
    },
    _refs = {},
    _vars = {};

  // PUBLIC
  return {
    _refs: {},
    _vars: {},
    // methods
    init: function init() {
      π.main.refs.body.on({
        'click': PRIV.onClick
      }, '.mixin-toggle-password');
    }
  };
}());;"use strict";

π.add('app.mixins.tooltip', function () {
  // PRIVATE
  var CONF = {
      'drift': 20
    },
    PRIV = {
      init: function init() {
        π.main.refs.body.find('.mixin-tooltip').each(function () {
          var that = $(this);
          var parent = that.closest('.tooltip-parent');
          if (!gl(parent)) {
            parent = that.parent();
          }
          var pos = parent.css('position');
          if (pos != 'absolute' && pos != 'fixed' && pos != 'relative') {
            parent.css({
              'position': 'relative'
            });
          }
          parent.addClass('tooltip-parent').closest('.form-box');
        });
      },
      addEventListener: function addEventListener() {
        π.main.refs.body.on({
          'click.tooltip': PRIV.onClickParent,
          'mouseenter.tooltip': PRIV.onMouseEnterParent,
          'mouseleave.tooltip': PRIV.onMouseLeaveParent
        }, '.tooltip-parent');
      },
      setSpacing: function setSpacing(that) {
        var width = π.helpers.style.getWidth(that.removeClass('wrap shift-left shift-right')),
          offsetLeft = gv(that.offset(), 'left');
        if (width > gv(π, 'main.window.innerWidth') - 60) {
          that.css('cssText', 'width: ' + (gv(π, 'main.window.innerWidth') - 60) + 'px !important;' + that.attr('style')).addClass('wrap');
        } else if (offsetLeft > gv(π, 'main.window.innerWidth')) {
          that.addClass('shift-left');
        } else if (offsetLeft < 0) {
          that.addClass('shift-right');
        }
      },
      setPrePosition: function setPrePosition(that) {
        var position = PRIV.getPosition(that.addClass('setup'));
        if (that.hasClass('top')) {
          that.css({
            'top': gv(position, 'top') - gv(CONF, 'drift'),
            'left': gv(position, 'left')
          });
        } else if (that.hasClass('bottom')) {
          that.css({
            'top': gv(position, 'top') + gv(CONF, 'drift'),
            'left': gv(position, 'left')
          });
        } else if (that.hasClass('left')) {
          that.css({
            'top': gv(position, 'top'),
            'left': gv(position, 'left') - gv(CONF, 'drift')
          });
        } else if (that.hasClass('right')) {
          that.css({
            'top': gv(position, 'top'),
            'left': gv(position, 'left') + gv(CONF, 'drift')
          });
        }
      },
      setPosition: function setPosition(that) {
        that.addClass('show').css(PRIV.getPosition(that));
      },
      show: function show(that) {
        if (!PRIV.isEmtpy(that) && !that.hasClass('disabled')) {
          PRIV.setPrePosition(that);
          PRIV.setSpacing(that);
          setTimeout(function () {
            return PRIV.setPosition(that);
          }, 1);
        }
      },
      hide: function hide() {
        var that = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : π.main.refs.body.find('.mixin-tooltip');
        clearTimeout(gv(_vars, 'timeoutDelay', false));
        that.removeClass('show setup');
      },
      isEmtpy: function isEmtpy(that) {
        var children = that.children();
        var empty = true;
        if (gl(children)) {
          children.each(function () {
            if (gl($.trim($(this).text()))) {
              empty = false;
            } else if (empty) {
              empty = PRIV.isEmtpy($(this));
            }
          });
        }
        return empty;
      },
      getPosition: function getPosition(that) {
        var width = π.helpers.style.getWidth(that),
          parent = that.closest('.tooltip-parent'),
          parentWidth = π.helpers.style.getWidth(parent),
          parentHeight = π.helpers.style.getHeight(parent),
          parentOffset = parent.offset(),
          parentViewportOffsetTop = gv(parentOffset, 'top') - gv(π, 'main.window.scrollTop'),
          parentViewportOffsetLeft = gv(parentOffset, 'left') - gv(π, 'main.window.scrollLeft');
        if (that.hasClass('top')) {
          return {
            'top': parentViewportOffsetTop + 6,
            'left': parentViewportOffsetLeft + parentWidth / 2
          };
        } else if (that.hasClass('bottom')) {
          return {
            'top': parentViewportOffsetTop + parentHeight,
            'left': parentViewportOffsetLeft + parentWidth / 2
          };
        } else if (that.hasClass('left')) {
          return {
            'top': parentViewportOffsetTop + parentHeight / 2,
            'left': parentViewportOffsetLeft - width
          };
        } else if (that.hasClass('right')) {
          return {
            'top': parentViewportOffsetTop + parentHeight / 2,
            'left': parentViewportOffsetLeft + parentWidth
          };
        }
      },
      onClickParent: function onClickParent(e) {
        var that = $(this).find('.mixin-tooltip'),
          isShow = that.hasClass('show'),
          isNoClick = that.hasClass('no-click'),
          isOnClickClose = that.hasClass('on-click-close'),
          isTooltipChild = gl($(gv(e, 'target')).closest('.mixin-tooltip'));
        if (gl(that)) {
          if (!isNoClick && !isTooltipChild) {
            clearTimeout(gv(_vars, 'timeoutDelay', false));
            if (!isShow) {
              PRIV.show(that);
            } else {
              PRIV.hide(that);
            }
          } else if (isOnClickClose && isTooltipChild && isShow) {
            clearTimeout(gv(_vars, 'timeoutDelay', false));
            PRIV.hide(that);
          }
        }
      },
      onMouseEnterParent: function onMouseEnterParent() {
        var that = $(this).find('.mixin-tooltip');
        if (π.helpers.data.isJQueryObject(that) && !that.hasClass('show') && !that.hasClass('no-tooltip-hover')) {
          clearTimeout(gv(_vars, 'timeoutDelay', false));
          _.set(_vars, 'timeoutDelay', setTimeout(function () {
            return PRIV.show(that);
          }, that.data('delay') || 0));
        }
      },
      onMouseLeaveParent: function onMouseLeaveParent() {
        π.main.refs.body.find('.mixin-tooltip').each(function () {
          var that = $(this);
          if (!that.hasClass('no-tooltip-hover')) {
            PRIV.hide(that);
          }
        });
      }
    },
    _refs = {},
    _vars = {
      timeoutDelay: undefined,
      timeoutMutation: undefined
    };

  // PUBLIC
  return {
    _refs: {},
    _vars: {},
    // methods
    init: function init() {
      PRIV.init();
      PRIV.addEventListener();
    },
    show: function show(that) {
      PRIV.show(that);
    },
    hide: function hide(that) {
      PRIV.hide();
    },
    disable: function disable(that) {
      that.addClass('disabled');
    },
    enable: function enable(that) {
      that.removeClass('disabled');
    },
    onScroll: function onScroll() {
      π.main.refs.body.find('.mixin-tooltip.show').each(function () {
        PRIV.setPosition($(this));
      });
    },
    onResize: function onResize() {
      var visibleTooltips = π.main.refs.body.find('.mixin-tooltip.show');
      PRIV.hide();
      setTimeout(function () {
        visibleTooltips.each(function () {
          PRIV.show($(this));
        });
      }, 1000);
    },
    onHTMLMutation: function onHTMLMutation(mutationRecords) {
      _.each(mutationRecords, function (mutationRecord) {
        if (!$(gv(mutationRecord, 'target', false)).hasClass('mixin-tooltip')) {
          π.helpers.utils.runOnceIn(function () {
            π.main.refs.body.find('.mixin-tooltip.show').each(function () {
              PRIV.setPosition($(this));
            });
          }, 1000);
          PRIV.init();
        }
      });
    }
  };
}());;// π.add('app._ext', (() => {
//     // PRIVATE
//     const
//         CONF = {},
//         PRIV = {},
//         _refs = {},
//         _vars = {};

//     // PUBLIC
//     return {
//         refs: {},
//         _vars: {},
//         // methods
//         init: function () {
//             // log('init project app._ext');
//         }
//     };
// })());
"use strict";;"use strict";

π.add('app.modules.overlay', function () {
  // PRIVATE
  var CONF = {
      popupIsAvailable: typeof $('#overlay').popup == 'function'
    },
    PRIV = {
      show: function show(content) {
        π.helpers.scroll.disable(gv(_refs, 'self').find('> .outer > .wrapper'));
        _.set(π, 'app.modules.overlay._vars.isVisible', true);
        π.app.modules.overlay.loading.hide();
        π.app.mixins.form.select.destroy(gv(_refs, 'self').find('select'));
        gv(_refs, 'self').find('> .outer > .wrapper > .close').removeClass('hide');
        gv(_refs, 'self').find('> .outer > .wrapper').scrollLeft(0).scrollTop(0);
        gv(_refs, 'self').trigger('ce.overlay.before-content');
        gv(_refs, 'self').find('> .outer > .wrapper > .content').html(content);
        gv(_refs, 'self').trigger('ce.overlay.before-show');
        gv(_refs, 'self').popup('show').trigger('ce.overlay.show');
      },
      load: function load(url) {
        gv(_refs, 'self').trigger('ce.overlay.before-load', [url]);
        if (gv(π.helpers.url.getQueryObject(url), 'overlay-loading', false)) {
          π.app.modules.overlay.loading.show();
        }
        π.app.helpers.api.get(url).then(PRIV.onLoad)["catch"](PRIV.onError);
      },
      close: function close() {
        gv(_refs, 'self').blur().popup('hide');
      },
      lock: function lock() {
        gv(_refs, 'self').addClass('locked');
      },
      unlock: function unlock() {
        gv(_refs, 'self').removeClass('locked');
      },
      checkUrl: function checkUrl() {
        var queryObject = π.helpers.url.getQueryObject();
        if (gv(queryObject, 'overlay-url', false)) {
          π.app.modules.overlay.load(decodeURIComponent(gv(queryObject, 'overlay-url')));
          _.unset(queryObject, 'overlay-url');
          π.helpers.url.historyPushState(queryObject);
        }
      },
      toggleBackButton: function toggleBackButton() {
        var backButton = gv(_refs, 'self').find('> .outer > .wrapper > .back'),
          isBackUrl = _.isString(gv(π.helpers.url.getQueryObject(gv(_vars, 'urls.url', false)), 'overlay-back', false)),
          isHistoryAvailable = gl(_vars, 'history') > 0,
          isEqualLastUrl = gv(_.last(gv(_vars, 'history')), 'url', false) == gv(_vars, 'urls.url', false);
        if (isBackUrl && isHistoryAvailable && !isEqualLastUrl) {
          var last = _.last(gv(_vars, 'history')),
            lastId = gv(last, 'id'),
            lastUrl = gv(last, 'url');
          backButton.attr('data-overlay-url', lastUrl).data('overlay-url', lastUrl).data('overlay-url-id', lastId).addClass('show');
        } else {
          backButton.removeAttr('data-overlay-url').removeData('overlay-url').removeData('overlay-url-id').removeClass('show');
        }
      },
      updateHistory: function updateHistory() {
        var isHistoryUrl = _.isString(gv(π.helpers.url.getQueryObject(gv(_vars, 'urls.url', false)), 'overlay-history', false)),
          isEqualLastUrl = gv(_.last(gv(_vars, 'history')), 'url', false) == gv(_vars, 'urls.url');
        if (isHistoryUrl && !isEqualLastUrl) {
          _.pull(gv(_vars, 'history'), {
            'url': gv(_vars, 'urls.url')
          });
          _.push(gv(_vars, 'history'), {
            'id': π.helpers.utils.getUniqueId(),
            'url': gv(_vars, 'urls.url')
          });
        }
      },
      setUrls: function setUrls(urls) {
        _.set(_vars, 'urls.url', _.isString(urls) ? urls : gv(urls, 'url', false) || undefined);
        _.set(_vars, 'urls.error', _.isObject(urls) ? gv(urls, 'error', false) : undefined);
        _.set(_vars, 'urls.success', _.isObject(urls) ? gv(urls, 'ssuccess', false) : undefined);
      },
      setCallbacks: function setCallbacks(callbacks) {
        _.set(_vars, 'callback', _.isFunction(callbacks) ? callbacks : undefined);
        _.set(_vars, 'callbackDone', gv(callbacks, 'done', false));
        _.set(_vars, 'callbackError', gv(callbacks, 'error', false));
      },
      onClick: function onClick(e) {
        e.preventDefault();
        var that = $(this),
          content = that.data('overlay-content');
        _.set(π, 'app.modules.overlay._refs.trigger', that);
        if (content) {
          PRIV.show(content);
        } else {
          PRIV.setUrls({
            'url': that.data('overlay-url'),
            'error': that.data('overlay-error'),
            'success': that.data('overlay-success')
          });
          PRIV.load(gv(_vars, 'urls.url'));
        }
      },
      onClickOverlay: function onClickOverlay(e) {
        if ($(gv(e, 'target')).hasClass('outer') && !gv(_refs, 'self').hasClass('loading') && !gv(_refs, 'self').hasClass('locked')) {
          PRIV.close();
        }
      },
      onClickClose: function onClickClose() {
        PRIV.close();
      },
      onClickBack: function onClickBack() {
        _.pullAt(gv(_vars, 'history'), _.range(_.findIndex(gv(_vars, 'history'), {
          'id': $(this).data('overlay-url-id')
        }), gl(_vars, 'history')));
      },
      onFormSubmit: function onFormSubmit(e) {
        var that = $(this);
        if (!that.hasClass('ajax-form') && !that.hasClass('custom-submit')) {
          e.preventDefault();
        }
      },
      onFormVerify: function onFormVerify(e, triggerEvent, triggerEventOptions) {
        if (gv(triggerEvent, 'type', false) == 'submit') {
          var that = $(this);
          if (!that.hasClass('ajax-form') && !that.hasClass('custom-submit') && !that.hasClass('error-flag')) {
            π.app.helpers.api.post(gv(this, 'action'), π.app.mixins.form.getFormData(that)).then(PRIV.onSuccess)["catch"](PRIV.onError);
          }
        }
      },
      onLoad: function onLoad(res) {
        if (gv(res, 'data.redirect', false)) {
          PRIV.load(gv(res, 'data.redirect'));
        } else if (gv(res, 'data.close', false)) {
          PRIV.close();
        } else if (gv(res, 'data.href', false)) {
          location.assign(gv(res, 'data.href'));
        } else {
          PRIV.show(gv(res, 'data.chunk'));
          PRIV.toggleBackButton();
          PRIV.updateHistory();
          if (_.isFunction(gv(_vars, 'callback', false))) {
            π.helpers.utils.applyMethod(_vars, 'callback', [res]);
          } else if (_.isFunction(gv(_vars, 'callbackDone', false))) {
            π.helpers.utils.applyMethod(_vars, 'callbackDone', [res]);
          } else {
            π.helpers.utils.applyMethod(π.app.modules.overlay, '_ext.onLoad', [res], this);
          }
          π.helpers.image.lazy.check();
          gv(_refs, 'self').trigger('ce.overlay.load');
        }
      },
      onSuccess: function onSuccess(res) {
        if (gv(_vars, 'urls.success', false)) {
          π.app.helpers.api.get(gv(_vars, 'urls.success')).then(PRIV.onLoad)["catch"](PRIV.onError);
        } else if (_.isFunction(gv(_vars, 'callback', false))) {
          π.helpers.utils.applyMethod(_vars, 'callback', [res]);
        } else if (_.isFunction(gv(_vars, 'callbackDone', false))) {
          π.helpers.utils.applyMethod(_vars, 'callbackDone', [res]);
        }
      },
      onError: function onError(err) {
        if (gv(_vars, 'urls.error', false)) {
          π.app.helpers.api.get(gv(_vars, 'urls.error')).then(PRIV.onLoad);
        } else {
          if (_.isFunction(gv(_vars, 'callback', false))) {
            π.helpers.utils.applyMethod(_vars, 'callback', [err]);
          } else if (_.isFunction(gv(_vars, 'callbackError', false))) {
            π.helpers.utils.applyMethod(_vars, 'callbackError', [err]);
          } else {
            π.helpers.utils.applyMethod(π.app.modules.overlay, '_ext.onError', [err]);
          }
          gv(_refs, 'self').trigger('ce.overlay.error', [err]);
        }
      },
      onClose: function onClose() {
        _.set(π, 'app.modules.overlay._vars.isVisible', false);
        _.set(π, 'app.modules.overlay._refs.trigger', undefined);
        π.app.mixins.form.select.close(gv(_refs, 'self').find('select'));
        π.app.mixins.form.select.destroy(gv(_refs, 'self').find('select'));
        π.helpers.scroll.enable(gv(_refs, 'self').find('> .outer > .wrapper'));
        gv(_refs, 'self').trigger('ce.overlay.close');
      },
      onClosed: function onClosed() {
        gv(_refs, 'self').trigger('ce.overlay.closed');
        gv(_refs, 'self').find('.content').html('');
        π.app.modules.overlay.loading.hide();
        _.set(_vars, 'history', []);
      }
    },
    _refs = {
      self: $('#overlay')
    },
    _vars = {
      urls: {
        url: undefined,
        error: undefined,
        success: undefined
      },
      callback: undefined,
      callbackDone: undefined,
      callbackError: undefined,
      history: []
    };

  // PUBLIC
  return {
    _refs: {
      self: $('#overlay'),
      trigger: undefined
    },
    _vars: {
      isVisible: false,
      isLoading: false
    },
    // methods
    init: function init() {
      if (gv(CONF, 'popupIsAvailable') && gl(_refs, 'self')) {
        gv(_refs, 'self').popup({
          'transition': 'all 0.5s',
          'blurignore': '.overlay-close-ignore',
          'escape': false,
          'onclose': PRIV.onClose,
          'closetransitionend': PRIV.onClosed
        }).on({
          'scroll': π.helpers.image.lazy.check
        });
        gv(_refs, 'self').on({
          'click': PRIV.onClickOverlay
        });
        π.main.refs.body.on({
          'click': PRIV.onClick
        }, '[data-overlay-url], [data-overlay-content]');
        π.main.refs.body.on({
          'click': PRIV.onClickClose
        }, '#overlay > .outer > .wrapper .close:not(.no-overlay-close)');
        π.main.refs.body.on({
          'click': PRIV.onClickBack
        }, '#overlay > .outer > .wrapper .back:not(.no-overlay-back)');
        π.main.refs.body.on({
          'submit': PRIV.onFormSubmit
        }, '#overlay form');
        π.main.refs.body.on({
          'ce.form.verify': PRIV.onFormVerify
        }, '#overlay form');
        PRIV.checkUrl();
      }
    },
    show: function show(content) {
      if (gv(CONF, 'popupIsAvailable') && gl(_refs, 'self') && gl(content)) {
        PRIV.show(content);
      }
    },
    load: function load() {
      var urls = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (gv(CONF, 'popupIsAvailable') && gl(_refs, 'self')) {
        PRIV.setUrls(urls);
        PRIV.setCallbacks(callbacks);
        PRIV.load(gv(_vars, 'urls.url'));
      }
    },
    reload: function reload() {
      if (gv(π, 'app.modules.overlay._vars.isVisible') && gl(_refs, 'self')) {
        PRIV.load(gv(_vars, 'urls.url'));
      }
    },
    close: function close() {
      if (gl(_refs, 'self')) {
        PRIV.close();
      }
    },
    lock: function lock() {
      if (gl(_refs, 'self')) {
        PRIV.lock();
      }
    },
    unlock: function unlock() {
      if (gl(_refs, 'self')) {
        PRIV.unlock();
      }
    },
    scrollTop: function scrollTop() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (gl(_refs, 'self')) {
        gv(_refs, 'self').scrollTop(value);
      }
    },
    getUrl: function getUrl() {
      return gl(_refs, 'self') ? gv(_vars, 'urls.url') : undefined;
    },
    onKeyDown: function onKeyDown(e) {
      if (gv(e, 'keyCode', false) == 27 && gl(_refs, 'self') && !gv(_refs, 'self').hasClass('loading') && !gv(_refs, 'self').hasClass('locked')) {
        // esc
        PRIV.close();
      }
    },
    // objects
    loading: {
      show: function show(text) {
        if (gl(_refs, 'self')) {
          if (!gv(π, 'app.modules.overlay._vars.isVisible')) {
            π.app.modules.overlay.show('<div class="loading-placeholder"></div>');
            gv(_refs, 'self').find('> .outer > .wrapper > .close').addClass('hide');
          }
          if (text) {
            gv(_refs, 'self').addClass('loading').find('> .outer > .wrapper > .loading').attr('data-text', text);
          }
          gv(_refs, 'self').addClass('loading').find('> .outer > .wrapper').scrollLeft(0).scrollTop(0);
          gv(_refs, 'self').addClass('loading').find('> .outer > .wrapper > .loading').addClass('show');
          _.set(π, 'app.modules.overlay._vars.isLoading', true);
        }
      },
      hide: function hide() {
        if (gl(_refs, 'self')) {
          gv(_refs, 'self').find('> .outer > .wrapper > .close').removeClass('hide');
          gv(_refs, 'self').removeClass('loading').find('> .outer > .wrapper > .loading').removeClass('show');
          _.set(π, 'app.modules.overlay._vars.isLoading', false);
        }
      }
    }
  };
}());;"use strict";

π.add('app.modules.slideup', function () {
  // PRIVATE
  var CONF = {},
    PRIV = {
      show: function show() {
        var that = $(this),
          content = π.main.refs.body.find(that.data('rel')),
          contents = π.main.refs.body.find('#slideup .contents');
        if (gl(content)) {
          PRIV.setActive(that);
          π.helpers.style.offTransitionEnd('#slideup .contents');
          π.helpers.style.onTransitionEnd('#slideup .contents', PRIV.onTransitionEnd);
          contents.addClass('show').find('.content').removeClass('show');
          contents.height(π.helpers.style.getHeight(content.addClass('show')));
          PRIV.setHeightChangeInterval(that);
        }
      },
      hide: function hide() {
        var self = π.main.refs.body.find('#slideup');
        self.find('.label[data-rel]').removeClass('active');
        self.find('.contents').removeClass('show').removeAttr('style');
        self.find('.content').removeClass('show');
      },
      load: function load(that, callback) {
        var content = π.main.refs.body.find(that.data('rel')),
          endpoint = '/rest/modules?query=' + π.helpers.json.getEncodedStringified({
            '_meta.name': 'globals/slideup'
          }),
          options = _.set({}, 'headers.Authorization', 'Bearer ' + content.data('api-token'));
        π.api.get(endpoint, options).then(function (res) {
          var key = that.data('rel').split('#slideup-')[1],
            ctn = gv(res, 'data.docs.0.content.' + key + '.content-ajax.ctn'),
            languageCookie = π.helpers.cookies.get('language'),
            languageDefault = gv(π, 'main.data.server.settings.languages.default', false),
            html = π.helpers.data.getValueTries(ctn, [undefined, languageCookie, languageDefault, function (that) {
              return gl(that) > 0;
            }]);
          content.html(html).removeData('api-token').removeAttr('data-api-token');
          π.helpers.utils.applyMethod(callback);
        })["catch"](function (err) {
          console.error(err);
        });
      },
      checkUrl: function checkUrl() {
        var slideup = π.helpers.url.getQueryValue('slideup');
        if (slideup) {
          gv(_refs, 'self').find('.label[data-rel="#slideup-' + slideup + '"]').trigger('click');
        }
      },
      scrollToTop: function scrollToTop(that, scrollElement) {
        var offset = gv(_refs, 'self').data('slideup-offset') || 0,
          scrollTop = gv(that.parent().offset(), 'top') - offset - 20,
          scrollLeft = gv(scrollElement, 'scrollLeft');
        scrollElement.scrollTo(scrollLeft, scrollTop);
      },
      setActive: function setActive(that) {
        that.parent().find('.label[data-rel]').removeClass('active');
        that.addClass('active');
      },
      setHeightChangeInterval: function setHeightChangeInterval(that) {
        PRIV.clearHeightChangeInterval();
        _.set(_vars, 'onHeightChangeInterval', setInterval(function () {
          return PRIV.scrollToTop(that, PRIV.getScrollElement());
        }, 1));
        setTimeout(PRIV.clearHeightChangeInterval, 1000);
      },
      clearHeightChangeInterval: function clearHeightChangeInterval() {
        clearInterval(gv(_vars, 'onHeightChangeInterval', false));
      },
      getScrollElement: function getScrollElement() {
        var element = π.helpers.scroll.getScrollElement();
        gv(_refs, 'self').parents().each(function () {
          var that = $(this);
          if (gv(this, 'tagName') != 'BODY' && ['auto', 'scroll'].includes(that.css('overflow-y'))) {
            return !(element = this);
          }
        });
        return element;
      },
      onClickLink: function onClickLink() {
        var _this = this;
        if (!$(this).hasClass('active')) {
          var that = $(this);
          if (π.main.refs.body.find(that.data('rel')).data('api-token')) {
            PRIV.load(that, function () {
              return PRIV.show.apply(_this);
            });
          } else {
            PRIV.show.apply(this);
          }
        } else {
          PRIV.hide();
        }
      },
      onClickClose: function onClickClose() {
        PRIV.hide();
      },
      onTransitionEnd: function onTransitionEnd() {
        PRIV.clearHeightChangeInterval();
      },
      onShowHiddenContent: function onShowHiddenContent() {
        var itemActive = gv(_refs, 'self').find('.label.active');
        if (gl(itemActive)) {
          PRIV.show.apply(itemActive[0]);
        }
      }
    },
    _refs = {
      self: $('#slideup')
    },
    _vars = {
      onHeightChangeInterval: undefined
    };

  // PUBLIC
  return _.get(_refs, 'self.length') ? {
    _refs: {},
    _vars: {},
    // methods
    init: function init() {
      π.main.refs.body.on({
        'click': PRIV.onClickLink
      }, '#slideup .label[data-rel]');
      π.main.refs.body.on({
        'click': PRIV.onClickClose
      }, '#slideup .close');
      π.main.refs.body.on({
        'ce.content.hidden.show': PRIV.onShowHiddenContent
      }, '#slideup > .contents > .content');
      PRIV.checkUrl();
    },
    onKeyDown: function onKeyDown(e) {
      if (gv(e, 'keyCode', false) == 27) {
        // esc
        PRIV.hide();
      }
    }
  } : undefined;
}());;"use strict";

π.add('app._ext', function () {
  // PRIVATE
  var CONF = {},
    PRIV = {},
    _refs = {},
    _vars = {};

  // PUBLIC
  return {
    init: function init() {
      π.helpers.mobile.disableZooming();
    }
  };
}());;"use strict";

π.add('app.modules.slideup._ext', function () {
  // PRIVATE
  var CONF = {},
    PRIV = {},
    _refs = {
      self: $('#slideup')
    },
    _vars = {};

  // PUBLIC
  return _.get(_refs, 'self.length') ? {
    _refs: {},
    _vars: {},
    // methods
    init: function init() {
      gv(_refs, 'self').data('slideup-offset', -20);
    }
  } : undefined;
}());
//# sourceMappingURL=basics.js.map
